import React, {Component} from "react";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import { Calendar } from 'primereact/calendar';
import {Dropdown} from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Chart } from 'primereact/chart';
import { Card } from 'primereact/card';
import axios from '../../axios-url';
import { ResponsiveNetwork } from '@nivo/network';
import { ResponsiveAreaBump } from '@nivo/bump';
import { ResponsiveBump } from '@nivo/bump';
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveChord } from '@nivo/chord';
//import { countries } from './index.ts';
import { ResponsiveChoropleth } from '@nivo/geo';

import { ResponsiveFunnel } from '@nivo/funnel'
import { ResponsiveHeatMap } from '@nivo/heatmap'
import { ResponsiveLine } from '@nivo/line';
import { ResponsiveMarimekko } from '@nivo/marimekko'
import { ResponsiveRadar } from '@nivo/radar'
import { ResponsiveSwarmPlot } from '@nivo/swarmplot'
import { ResponsiveScatterPlot } from '@nivo/scatterplot'
import { ResponsiveCirclePacking } from '@nivo/circle-packing'
import { DROPDOWN_CONFIG,USER_SUBMENU_ID} from '../../shared/Config';
import { REDIRECT_TO_URL, HASACCESS } from '../../shared/utility';
import { Toast } from 'primereact/toast';
import Messages from '../../shared/UI/Messages/Messages';

import { MYTEAM_SUBMENU_ID, VIDEO_SUBMENU_ID, NEWS_DASHBOARD_SUBMENU_ID, HOLIDAY_DASHBOARD_SUBMENU_ID, MYLEAVEBAL_SUBMENU_ID, REQSTATISTICS_SUBMENU_ID, LEAVE_REQUEST_ID, ADDITIONAL_LEAVE_QUOTA_ID, WORK_SCHEDULE_ID, VACATION_PLAN_ID, OVERTIME_PREAPPROVAL_ID, BREAK_PERMISSION_ID, LEAVE_CANCELLATION_ID, PAYROLL_REPORT_ID, FLEXIBLE_TIMING_ID, TIMESHEET_ID, 
    JOB_REQUISITIONS_ID, SHORT_LISTING_ID, JOB_INTERVIEW_ID, RANKING_PROCESS_ID, JOINING_PROCESS_ID, JOB_APPLICATION_ID,RECRUITMENT_SUBMENU_ID, TRAVEL_AUTHORIZATION_ID, BUSINESS_TRIP_ID,GATEPASS_VISITOR_ID,MATERIAL_PASS_IN_ID,MATERIAL_PASS_OUT_ID,MATERIAL_PASS_VEHICLE_ID, WORK_PERMIT_ID, WCA_INBOX_SUBMENU_ID, ATTENDANCECHART_SUBMENU_ID, PROCESS_INCIDENT_REPORT_ID, CALENDAR_SUBMENU_ID, WCA_STATISTICS_SUBMENU_ID, SAFETY_CONTROLLER_LIST_SUBMENU_ID, ACCEPTOR_LIST_SUBMENU_ID, SIMULATION_ID, HEADCOUNT_CHART_ID, MOC_ID,TMOC_ID,SERVICE_ID, LEAVE_HEADCOUNT_CHART_ID,MONTHLY_EVALUATION_ID,HDS_INCIDENT_ID,HDS_PROBLEM_ID,HDS_CHANGE_ID,KPI_TARGET_ID,FI_INVOICE_ID,KPI_ACTUAL_ID,HR_ANALYTICS,OM_ANALYTICS} from '../../shared/Config';
   



class OrgStruct extends Component {
     constructor(props){
         super(props);
        this.state = {
          organizationData: [],
          Fromdate: null,
          ToDate: null,
          SelectedOrg:null,
          GetOrgUnit:[],
          touch:false,
          loading: false,
          Department: [
            {label: 'Purchase Dep', value: '99BDDDB4-77EB-479A-9673-0A865F23CCC9'},
            {label: 'Finance', value: '8EF08393-9DB8-4654-83EC-134C6015A074'},
            {label : 'IT Dept',value : 'EB9323B6-AB93-4453-914C-26286F824C00'},
            {label : 'HSE',value : 'D55895CA-D7FC-4E5F-BBB7-30D195D475F1'},
            {label: 'Apprentice', value: '7EADDA05-B367-448F-8A33-654FC83EB07D'},
            {label: 'Chemist Depa', value: 'B63D1B09-67B3-40BA-8808-675DA62A82BE'},
            {label: 'Accountant', value: '1C51468A-BE18-42BE-832E-6C79A3A5A10F'},
            {label: 'Ware House', value: 'D5EBDE56-1670-4BA5-96A9-77C523DF9C3C'},
            {label: 'Engineering', value: '3A055B98-C7CE-4498-90C8-795B6C722590'},
            {label: 'Maintenance', value: '5708A1DF-01BE-48B5-881E-79B2D2AA30F7'},
            {label: 'Training Dep', value: 'B98A1E76-A9B7-446D-8EC1-8BBCA8090669'},
            {label: 'HR & Admin', value: '76B77363-3BAB-4780-BB29-9BAB5B7949C2'},
            {label: 'HR departmen', value: 'B423B9DA-737A-4BC0-9195-B93E4F16FCE3'},
            {label: 'Lead Mech En', value: '7F2C8AB4-57D9-4770-9B29-BD200F3AF45E'},
            {label: 'Lead C&I Eng', value: 'C26E20D6-F5FE-4E48-8F9B-BF6A260B7A67'},
            {label: 'Deputy Opera', value: '43698F7A-B3FA-488C-982B-CEE4C7305E9E'},
            {label: 'Performance', value: '76F0B9B0-7580-43E3-8330-D364D11C626D'},
            {label: 'Lead El Eng', value: '831C833E-355E-4F34-B23F-D6C3FC2E1389'},
            {label: 'Planning Eng', value: '4FA056A1-7834-4F38-87A8-D78AE5AD58BE'},
            {label: 'Operations', value: '0879E6FD-30AE-4BFB-9987-DE5DDADD8D13'},
            {label: 'Conditioning', value: 'C39CD747-C43C-4CA8-9910-ED44DC6D1B79'},
            {label: 'Security Dep', value: '80354382-9FF6-4D29-8BC7-EF901C4356DD'},
            
        ],

        }
        //this.change = this.change.bind(this);
    }



    // make sure parent container have a defined height when using
    // responsive component, otherwise height will be 0 and
    // no chart will be rendered.
    // website examples showcase many properties,
    // you'll often use just a few of them.





    componentDidMount(){
      this.props.getRequest();
      this.props.getMasterKeywordList('OrgUnit');
     // this.props.GetPositionHierachyGraph();
      this.getAccess = HASACCESS(USER_SUBMENU_ID);
      let id = this.props.match.params.id;
      this.props.getMasterTableList('GeUsers?id='+id);   
 
     //   axios.get('/master/api/GetHRAnalytics?EMPLOYEEID="b2019f12-59bd-4ba2-916b-92e3d4f6bd65"&YEAR="2021"&MONTH="01"&DEPARTMENTNO="10000005"').then((response) => {
            // console.log({response})
     //   })
     this.setState({ loading: true });
     setTimeout(() =>{
      // if(this.props.requestListData[4] !== undefined){
      //     if(this.props.requestListData[4].length > 0){
      //         this.setState({showteamMembers: true})
      //     }
      // }
      // if (this.state.viewCalendarFor== undefined){
      // this.setState({viewCalendarFor:this.props.loggedUserDetail.empID});
      // }
     
  },10000)

  setTimeout(() => {
    this.setState({loading: true});
    this.getTeamAccess = HASACCESS(MYTEAM_SUBMENU_ID);
    this.getVideoAccess = HASACCESS(VIDEO_SUBMENU_ID);
    this.getNewsAccess = HASACCESS(NEWS_DASHBOARD_SUBMENU_ID);
    this.getHolidayAccess = HASACCESS(HOLIDAY_DASHBOARD_SUBMENU_ID);
    this.getLeaveChartAccess = HASACCESS(MYLEAVEBAL_SUBMENU_ID);
    this.getRequestsAccess = HASACCESS(REQSTATISTICS_SUBMENU_ID);
    this.getRecruitmentAccess = HASACCESS(RECRUITMENT_SUBMENU_ID);
    this.getOperationRequestsAccess = HASACCESS(WCA_INBOX_SUBMENU_ID);
    this.getAttendanceChartAccess = HASACCESS(ATTENDANCECHART_SUBMENU_ID);
    this.getCalendarAccess = HASACCESS(CALENDAR_SUBMENU_ID);
    this.getWcaStatisticsAccess = HASACCESS(WCA_STATISTICS_SUBMENU_ID);
    this.getSafetyControllerListAccess = HASACCESS(SAFETY_CONTROLLER_LIST_SUBMENU_ID);
    this.getAcceptorListAccess = HASACCESS(ACCEPTOR_LIST_SUBMENU_ID);
    this.getHeadCountChrtAccess =  HASACCESS(HEADCOUNT_CHART_ID);
    this.getLeaveHeadCountChrtAccess =  HASACCESS(LEAVE_HEADCOUNT_CHART_ID);            
    
    this.setState({loading: false});
},4000)

  this.setState({ loading: false });
        // axios.get('/master/api/Employee/GetPositionHierachyGraph').then((response) => {
        //     if (response.status === 200) {

        //         if (response.data && response.data.length > 0) {
        //             let organizationData = response.data;
        //             //organizationData = [...new Set(organizationData.map(({ name,color,loc,children }) => ({name,color,loc,children})))];
        //             organizationData = [...new Set(organizationData.map(({ name, color, loc, children }) => ({name,color,loc,
        //               children: children.map(({ name,color,loc,children }) => ({name,color,loc,children: children.map(({ name,color,loc,children }) => ({name,color,loc,children:children.map(({ name,color,loc }) => ({name,color,loc })) })) })),
        //             })))];
        //              //console.log({organizationData})
        //              this.setState({ organizationData});
        //              this.setState({ loading: false });
        //         }
        //     }
        //     else {
        //         this.setState({ loading: false });
        //         this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
        //     }
        // })
        //this.timer();
        
    }
    // timer = () =>{
    //   this.intervalID = setInterval(()=> {
    //       this.fetchSingleProcess();
    //   },2000)
 // }  
//   fetchSingleProcess = () =>{

//     let storageItems = [];
//     if(this.props.OrgUnit!==undefined) {
//         storageItems = this.props.OrgUnit;
//         clearInterval(this.intervalID);
//     }
//     if(storageItems){
//         let filterData = storageItems;
//         if(filterData){
//             let org ='';
//             if(filterData!=null){
//                 org = filterData.split(",") 
//             }

//             var data = {
           
//                 orgid: org,
//             }
//             this.setState(data);
            
//         }
//     }

// }


    // shouldComponentUpdate(prevProps, prevState){
    //   if (prevProps.positionhierarchyData !== this.props.positionhierarchyData) {
    //     return true;
    // } else {
    //     return false;
    // }
    // }


    updateDetail = (e) => {
      const { name, value} = e.target;
      this.setState({[name]:value});
  }
  change = (e) => {
    let {name, value} = e.target;
    this.setState({[name]:value})
}

    render(){
      // let depOptions = [];
      const { positionhierarchyData} = this.props;
      
      const { requestListData, calendarData} = this.props;
      //  if(positionhierarchyData && positionhierarchyData.length > 0 ){
      //   let organizationData = this.props.positionhierarchyData
      //  // let organizationData = [...new Set(positionhierarchyData.map(({ name,color,loc,children }) => ({name,color,loc,children})))];
      //   organizationData = {...organizationData.map(({ name, color, children }) => ({name,color,
      //     children: children.map(({ name,color,children }) => ({name,color,children: children.map(({ name,color,children }) => ({name,color,children:children.map(({ name,color,loc }) => ({name,color,loc })) })) })),
      //   }))};
      //   this.setState({ organizationData});
      //  }
      
      // if(this.props.emp && this.props.emp.length > 0 ){
      //   depOptions = this.props.emp;
      // }
       // const { requestListData} = this.props;

       let getHolidayAccess = false;
       let getLeaveChartAccess = false;
       let getNewsAccess = false;
       let getRecruitmentAccess = false;
       let getRequestsAccess = false;
       let getTeamAccess = false;
       let getVideoAccess = false;
       let getOperationRequestsAccess = false;
       let getAttendanceChartAccess = false;
       let getCalendarAccess = false;
       let getWcaStatisticsAccess = false;
       let getSafetyControllerListAccess = false;
       let getAcceptorListAccess = false;
       let getHeadCountChrtAccess = false;
       let getLeaveHeadCountChrtAccess = false;             
       let AnnualLeaveHC= (headCountData && headCountData.length > 0  && headCountData.find(el =>el.status == "Annual Leave")) ? headCountData.find(el =>el.status == "Annual Leave") : {count: 0};
       let SickLeaveHC = (headCountData && headCountData.length > 0  &&  headCountData.find(el => el.status == "Sick leave 100% Paid")) ? headCountData.find(el => el.status == "Sick leave 100% Paid") : {count: 0};


        let isEnabled = (this.state.touch === true);

        const bumpd=  

[
  {
    "id": "JavaScript",
    "data": [
      {
        "x": 2000,
        "y": 12
      },
      {
        "x": 2001,
        "y": 22
      },
      {
        "x": 2002,
        "y": 11
      },
      {
        "x": 2003,
        "y": 16
      },
      {
        "x": 2004,
        "y": 23
      },
      {
        "x": 2005,
        "y": 17
      }
    ]
  },
  {
    "id": "ReasonML",
    "data": [
      {
        "x": 2000,
        "y": 25
      },
      {
        "x": 2001,
        "y": 14
      },
      {
        "x": 2002,
        "y": 18
      },
      {
        "x": 2003,
        "y": 20
      },
      {
        "x": 2004,
        "y": 27
      },
      {
        "x": 2005,
        "y": 16
      }
    ]
  },
  {
    "id": "TypeScript",
    "data": [
      {
        "x": 2000,
        "y": 20
      },
      {
        "x": 2001,
        "y": 11
      },
      {
        "x": 2002,
        "y": 25
      },
      {
        "x": 2003,
        "y": 14
      },
      {
        "x": 2004,
        "y": 16
      },
      {
        "x": 2005,
        "y": 25
      }
    ]
  },
  {
    "id": "Elm",
    "data": [
      {
        "x": 2000,
        "y": 17
      },
      {
        "x": 2001,
        "y": 30
      },
      {
        "x": 2002,
        "y": 25
      },
      {
        "x": 2003,
        "y": 22
      },
      {
        "x": 2004,
        "y": 26
      },
      {
        "x": 2005,
        "y": 29
      }
    ]
  },
  {
    "id": "CoffeeScript",
    "data": [
      {
        "x": 2000,
        "y": 13
      },
      {
        "x": 2001,
        "y": 20
      },
      {
        "x": 2002,
        "y": 19
      },
      {
        "x": 2003,
        "y": 24
      },
      {
        "x": 2004,
        "y": 17
      },
      {
        "x": 2005,
        "y": 13
      }
    ]
  }
]
            
const bard = [
    {
      "country": "AD",
      "hot dog": 182,
      "hot dogColor": "hsl(70, 70%, 50%)",
      "burger": 170,
      "burgerColor": "hsl(146, 70%, 50%)",
      "sandwich": 183,
      "sandwichColor": "hsl(106, 70%, 50%)",
      "kebab": 69,
      "kebabColor": "hsl(303, 70%, 50%)",
      "fries": 33,
      "friesColor": "hsl(303, 70%, 50%)",
      "donut": 90,
      "donutColor": "hsl(341, 70%, 50%)"
    },
    {
      "country": "AE",
      "hot dog": 99,
      "hot dogColor": "hsl(74, 70%, 50%)",
      "burger": 99,
      "burgerColor": "hsl(283, 70%, 50%)",
      "sandwich": 129,
      "sandwichColor": "hsl(102, 70%, 50%)",
      "kebab": 0,
      "kebabColor": "hsl(170, 70%, 50%)",
      "fries": 155,
      "friesColor": "hsl(249, 70%, 50%)",
      "donut": 48,
      "donutColor": "hsl(23, 70%, 50%)"
    },
    {
      "country": "AF",
      "hot dog": 128,
      "hot dogColor": "hsl(70, 70%, 50%)",
      "burger": 107,
      "burgerColor": "hsl(104, 70%, 50%)",
      "sandwich": 71,
      "sandwichColor": "hsl(144, 70%, 50%)",
      "kebab": 15,
      "kebabColor": "hsl(315, 70%, 50%)",
      "fries": 76,
      "friesColor": "hsl(61, 70%, 50%)",
      "donut": 34,
      "donutColor": "hsl(36, 70%, 50%)"
    },
    {
      "country": "AG",
      "hot dog": 89,
      "hot dogColor": "hsl(318, 70%, 50%)",
      "burger": 154,
      "burgerColor": "hsl(240, 70%, 50%)",
      "sandwich": 102,
      "sandwichColor": "hsl(46, 70%, 50%)",
      "kebab": 153,
      "kebabColor": "hsl(226, 70%, 50%)",
      "fries": 193,
      "friesColor": "hsl(350, 70%, 50%)",
      "donut": 33,
      "donutColor": "hsl(247, 70%, 50%)"
    },
    {
      "country": "AI",
      "hot dog": 51,
      "hot dogColor": "hsl(3, 70%, 50%)",
      "burger": 157,
      "burgerColor": "hsl(70, 70%, 50%)",
      "sandwich": 174,
      "sandwichColor": "hsl(126, 70%, 50%)",
      "kebab": 21,
      "kebabColor": "hsl(186, 70%, 50%)",
      "fries": 12,
      "friesColor": "hsl(205, 70%, 50%)",
      "donut": 36,
      "donutColor": "hsl(163, 70%, 50%)"
    },
    {
      "country": "AL",
      "hot dog": 126,
      "hot dogColor": "hsl(71, 70%, 50%)",
      "burger": 140,
      "burgerColor": "hsl(17, 70%, 50%)",
      "sandwich": 174,
      "sandwichColor": "hsl(242, 70%, 50%)",
      "kebab": 131,
      "kebabColor": "hsl(261, 70%, 50%)",
      "fries": 52,
      "friesColor": "hsl(247, 70%, 50%)",
      "donut": 134,
      "donutColor": "hsl(128, 70%, 50%)"
    },
    {
      "country": "AM",
      "hot dog": 186,
      "hot dogColor": "hsl(339, 70%, 50%)",
      "burger": 28,
      "burgerColor": "hsl(342, 70%, 50%)",
      "sandwich": 117,
      "sandwichColor": "hsl(130, 70%, 50%)",
      "kebab": 136,
      "kebabColor": "hsl(234, 70%, 50%)",
      "fries": 27,
      "friesColor": "hsl(28, 70%, 50%)",
      "donut": 197,
      "donutColor": "hsl(59, 70%, 50%)"
    }
  ]
  const pied = [
    {
      "id": "elixir",
      "label": "elixir",
      "value": 506,
      "color": "hsl(302, 70%, 50%)"
    },
    {
      "id": "rust",
      "label": "rust",
      "value": 55,
      "color": "hsl(11, 70%, 50%)"
    },
    {
      "id": "go",
      "label": "go",
      "value": 538,
      "color": "hsl(238, 70%, 50%)"
    },
    {
      "id": "stylus",
      "label": "stylus",
      "value": 508,
      "color": "hsl(253, 70%, 50%)"
    },
    {
      "id": "java",
      "label": "java",
      "value": 358,
      "color": "hsl(84, 70%, 50%)"
    }
  ]


        const data1 = {
            "nodes": [
              {
                "id": "Node 1",
                "height": 1,
                "size": 24,
                "color": "rgb(97, 205, 187)",
                "label": '12345678'
              },
              {
                "id": "Node 2",
                "height": 1,
                "size": 24,
                "color": "rgb(97, 205, 187)",
                "label": "12345678"
              },
              {
                "id": "Node 0",
                "height": 2,
                "size": 32,
                "color": "rgb(244, 117, 96)",
                "label": "12345678"
              },
              {
                "id": "Node 1.0",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 1.1",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 1.2",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 2.0",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
              {
                "id": "Node 2.1",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label":  "12345678"
              },
              {
                "id": "Node 2.2",
                "height": 0,
                "size": 12,
                "color": "rgb(232, 193, 160)",
                "label": "12345678"
              },
            ],
            "links": [
              {
                "source": "Node 0",
                "target": "Node 1",
                "distance": 80
              },
              {
                "source": "Node 1",
                "target": "Node 1.0",
                "distance": 50
              },
              {
                "source": "Node 1",
                "target": "Node 1.1",
                "distance": 50
              },
              {
                "source": "Node 1",
                "target": "Node 1.2",
                "distance": 50
              },
              {
                "source": "Node 0",
                "target": "Node 2",
                "distance": 80
              },
              {
                "source": "Node 2",
                "target": "Node 2.0",
                "distance": 50
              },
              {
                "source": "Node 2",
                "target": "Node 2.1",
                "distance": 50
              },
              {
                "source": "Node 2",
                "target": "Node 2.2",
                "distance": 50
              },
            ]
          }  

          const chordd =         [
            [
              756,
              280,
              370,
              786,
              388
            ],
            [
              161,
              853,
              394,
              51,
              33
            ],
            [
              318,
              1834,
              391,
              994,
              294
            ],
            [
              361,
              415,
              445,
              424,
              1939
            ],
            [
              265,
              895,
              339,
              992,
              328
            ]
          ]  
          
          const dmap = [
            {
              "id": "AFG",
              "value": 659788
            },
            {
              "id": "AGO",
              "value": 242152
            },
            {
              "id": "ALB",
              "value": 900201
            },
            {
              "id": "ARE",
              "value": 279376
            },
            {
              "id": "ARG",
              "value": 626164
            },
            {
              "id": "ARM",
              "value": 422370
            },
            {
              "id": "ATA",
              "value": 483257
            },
            {
              "id": "ATF",
              "value": 711345
            },
            {
              "id": "AUT",
              "value": 40733
            },
            {
              "id": "AZE",
              "value": 234404
            },
            {
              "id": "BDI",
              "value": 55264
            },
            {
              "id": "BEL",
              "value": 506598
            },
            {
              "id": "BEN",
              "value": 703536
            },
            {
              "id": "BFA",
              "value": 259673
            },
            {
              "id": "BGD",
              "value": 132169
            },
            {
              "id": "BGR",
              "value": 571290
            },
            {
              "id": "BHS",
              "value": 500630
            },
            {
              "id": "BIH",
              "value": 887627
            },
            {
              "id": "BLR",
              "value": 444028
            },
            {
              "id": "BLZ",
              "value": 999206
            },
            {
              "id": "BOL",
              "value": 89675
            },
            {
              "id": "BRN",
              "value": 707451
            },
            {
              "id": "BTN",
              "value": 451415
            },
            {
              "id": "BWA",
              "value": 166636
            },
            {
              "id": "CAF",
              "value": 815231
            },
            {
              "id": "CAN",
              "value": 681485
            },
            {
              "id": "CHE",
              "value": 767043
            },
            {
              "id": "CHL",
              "value": 5364
            },
            {
              "id": "CHN",
              "value": 550717
            },
            {
              "id": "CIV",
              "value": 210843
            },
            {
              "id": "CMR",
              "value": 125717
            },
            {
              "id": "COG",
              "value": 830619
            },
            {
              "id": "COL",
              "value": 622319
            },
            {
              "id": "CRI",
              "value": 219133
            },
            {
              "id": "CUB",
              "value": 770961
            },
            {
              "id": "-99",
              "value": 31794
            },
            {
              "id": "CYP",
              "value": 260908
            },
            {
              "id": "CZE",
              "value": 46928
            },
            {
              "id": "DEU",
              "value": 972487
            },
            {
              "id": "DJI",
              "value": 995504
            },
            {
              "id": "DNK",
              "value": 320483
            },
            {
              "id": "DOM",
              "value": 71138
            },
            {
              "id": "DZA",
              "value": 634804
            },
            {
              "id": "ECU",
              "value": 362073
            },
            {
              "id": "EGY",
              "value": 304745
            },
            {
              "id": "ERI",
              "value": 906067
            },
            {
              "id": "ESP",
              "value": 21735
            },
            {
              "id": "EST",
              "value": 907725
            },
            {
              "id": "ETH",
              "value": 601100
            },
            {
              "id": "FIN",
              "value": 827637
            },
            {
              "id": "FJI",
              "value": 209230
            },
            {
              "id": "FLK",
              "value": 643658
            },
            {
              "id": "FRA",
              "value": 198701
            },
            {
              "id": "GAB",
              "value": 811550
            },
            {
              "id": "GBR",
              "value": 388676
            },
            {
              "id": "GEO",
              "value": 819866
            },
            {
              "id": "GHA",
              "value": 429105
            },
            {
              "id": "GIN",
              "value": 9464
            },
            {
              "id": "GMB",
              "value": 280997
            },
            {
              "id": "GNB",
              "value": 288504
            },
            {
              "id": "GNQ",
              "value": 79511
            },
            {
              "id": "GRC",
              "value": 341270
            },
            {
              "id": "GTM",
              "value": 826831
            },
            {
              "id": "GUY",
              "value": 121279
            },
            {
              "id": "HND",
              "value": 42365
            },
            {
              "id": "HRV",
              "value": 579447
            },
            {
              "id": "HTI",
              "value": 378491
            },
            {
              "id": "HUN",
              "value": 44827
            },
            {
              "id": "IDN",
              "value": 482295
            },
            {
              "id": "IND",
              "value": 318980
            },
            {
              "id": "IRL",
              "value": 974338
            },
            {
              "id": "IRN",
              "value": 819656
            },
            {
              "id": "IRQ",
              "value": 159916
            },
            {
              "id": "ISL",
              "value": 539241
            },
            {
              "id": "ISR",
              "value": 856237
            },
            {
              "id": "ITA",
              "value": 244017
            },
            {
              "id": "JAM",
              "value": 649728
            },
            {
              "id": "JOR",
              "value": 333274
            },
            {
              "id": "JPN",
              "value": 981054
            },
            {
              "id": "KAZ",
              "value": 795992
            },
            {
              "id": "KEN",
              "value": 700166
            },
            {
              "id": "KGZ",
              "value": 368359
            },
            {
              "id": "KHM",
              "value": 993820
            },
            {
              "id": "OSA",
              "value": 714423
            },
            {
              "id": "KWT",
              "value": 772037
            },
            {
              "id": "LAO",
              "value": 288865
            },
            {
              "id": "LBN",
              "value": 45317
            },
            {
              "id": "LBR",
              "value": 749391
            },
            {
              "id": "LBY",
              "value": 228944
            },
            {
              "id": "LKA",
              "value": 823996
            },
            {
              "id": "LSO",
              "value": 400198
            },
            {
              "id": "LTU",
              "value": 920277
            },
            {
              "id": "LUX",
              "value": 954995
            },
            {
              "id": "LVA",
              "value": 161175
            },
            {
              "id": "MAR",
              "value": 264495
            },
            {
              "id": "MDA",
              "value": 56342
            },
            {
              "id": "MDG",
              "value": 758573
            },
            {
              "id": "MEX",
              "value": 71321
            },
            {
              "id": "MKD",
              "value": 535968
            },
            {
              "id": "MLI",
              "value": 998058
            },
            {
              "id": "MMR",
              "value": 273467
            },
            {
              "id": "MNE",
              "value": 385592
            },
            {
              "id": "MNG",
              "value": 142728
            },
            {
              "id": "MOZ",
              "value": 755671
            },
            {
              "id": "MRT",
              "value": 998745
            },
            {
              "id": "MWI",
              "value": 747710
            },
            {
              "id": "MYS",
              "value": 275835
            },
            {
              "id": "NAM",
              "value": 262796
            },
            {
              "id": "NCL",
              "value": 108296
            },
            {
              "id": "NER",
              "value": 505986
            },
            {
              "id": "NGA",
              "value": 977308
            },
            {
              "id": "NIC",
              "value": 137665
            },
            {
              "id": "NLD",
              "value": 542313
            },
            {
              "id": "NOR",
              "value": 579764
            },
            {
              "id": "NPL",
              "value": 657797
            },
            {
              "id": "NZL",
              "value": 856319
            },
            {
              "id": "OMN",
              "value": 129176
            },
            {
              "id": "PAK",
              "value": 61675
            },
            {
              "id": "PAN",
              "value": 690074
            },
            {
              "id": "PER",
              "value": 220977
            },
            {
              "id": "PHL",
              "value": 816757
            },
            {
              "id": "PNG",
              "value": 646094
            },
            {
              "id": "POL",
              "value": 945580
            },
            {
              "id": "PRI",
              "value": 188993
            },
            {
              "id": "PRT",
              "value": 241319
            },
            {
              "id": "PRY",
              "value": 270857
            },
            {
              "id": "QAT",
              "value": 587597
            },
            {
              "id": "ROU",
              "value": 920155
            },
            {
              "id": "RUS",
              "value": 419103
            },
            {
              "id": "RWA",
              "value": 749523
            },
            {
              "id": "ESH",
              "value": 982477
            },
            {
              "id": "SAU",
              "value": 435628
            },
            {
              "id": "SDN",
              "value": 344721
            },
            {
              "id": "SDS",
              "value": 178267
            },
            {
              "id": "SEN",
              "value": 176801
            },
            {
              "id": "SLB",
              "value": 98743
            },
            {
              "id": "SLE",
              "value": 584295
            },
            {
              "id": "SLV",
              "value": 317579
            },
            {
              "id": "ABV",
              "value": 100109
            },
            {
              "id": "SOM",
              "value": 761672
            },
            {
              "id": "SRB",
              "value": 440203
            },
            {
              "id": "SUR",
              "value": 654301
            },
            {
              "id": "SVK",
              "value": 848453
            },
            {
              "id": "SVN",
              "value": 308409
            },
            {
              "id": "SWZ",
              "value": 997161
            },
            {
              "id": "SYR",
              "value": 905370
            },
            {
              "id": "TCD",
              "value": 481278
            },
            {
              "id": "TGO",
              "value": 821773
            },
            {
              "id": "THA",
              "value": 993579
            },
            {
              "id": "TJK",
              "value": 935132
            },
            {
              "id": "TKM",
              "value": 255921
            },
            {
              "id": "TLS",
              "value": 524378
            },
            {
              "id": "TTO",
              "value": 427108
            },
            {
              "id": "TUN",
              "value": 720064
            },
            {
              "id": "TUR",
              "value": 271665
            },
            {
              "id": "TWN",
              "value": 193043
            },
            {
              "id": "TZA",
              "value": 159662
            },
            {
              "id": "UGA",
              "value": 165526
            },
            {
              "id": "UKR",
              "value": 731726
            },
            {
              "id": "URY",
              "value": 407882
            },
            {
              "id": "USA",
              "value": 354130
            },
            {
              "id": "UZB",
              "value": 279111
            },
            {
              "id": "VEN",
              "value": 431467
            },
            {
              "id": "VNM",
              "value": 507206
            },
            {
              "id": "VUT",
              "value": 571424
            },
            {
              "id": "PSE",
              "value": 458472
            },
            {
              "id": "YEM",
              "value": 684206
            },
            {
              "id": "ZAF",
              "value": 550425
            },
            {
              "id": "ZMB",
              "value": 857009
            },
            {
              "id": "ZWE",
              "value": 601980
            },
            {
              "id": "KOR",
              "value": 984272
            }
          ]
const dfun =[
  {
    "id": "step_sent",
    "value": 88446,
    "label": "Sent"
  },
  {
    "id": "step_viewed",
    "value": 55625,
    "label": "Viewed"
  },
  {
    "id": "step_clicked",
    "value": 49967,
    "label": "Clicked"
  },
  {
    "id": "step_add_to_card",
    "value": 31645,
    "label": "Add To Card"
  },
  {
    "id": "step_purchased",
    "value": 22962,
    "label": "Purchased"
  }
]
const dheat = [
  {
    "id": "Japan",
    "data": [
      {
        "x": "Train",
        "y": 11390
      },
      {
        "x": "Subway",
        "y": 76644
      },
      {
        "x": "Bus",
        "y": 58831
      },
      {
        "x": "Car",
        "y": 58375
      },
      {
        "x": "Boat",
        "y": 25990
      },
      {
        "x": "Moto",
        "y": 66675
      },
      {
        "x": "Moped",
        "y": -50387
      },
      {
        "x": "Bicycle",
        "y": 45745
      },
      {
        "x": "Others",
        "y": 18725
      }
    ]
  },
  {
    "id": "France",
    "data": [
      {
        "x": "Train",
        "y": -76215
      },
      {
        "x": "Subway",
        "y": -69073
      },
      {
        "x": "Bus",
        "y": -3263
      },
      {
        "x": "Car",
        "y": -35509
      },
      {
        "x": "Boat",
        "y": 78630
      },
      {
        "x": "Moto",
        "y": -17985
      },
      {
        "x": "Moped",
        "y": 23569
      },
      {
        "x": "Bicycle",
        "y": 97667
      },
      {
        "x": "Others",
        "y": -79456
      }
    ]
  },
  {
    "id": "US",
    "data": [
      {
        "x": "Train",
        "y": -33215
      },
      {
        "x": "Subway",
        "y": -49349
      },
      {
        "x": "Bus",
        "y": -77058
      },
      {
        "x": "Car",
        "y": -18747
      },
      {
        "x": "Boat",
        "y": 99783
      },
      {
        "x": "Moto",
        "y": 90766
      },
      {
        "x": "Moped",
        "y": 29266
      },
      {
        "x": "Bicycle",
        "y": -87450
      },
      {
        "x": "Others",
        "y": 9379
      }
    ]
  },
  {
    "id": "Germany",
    "data": [
      {
        "x": "Train",
        "y": -66332
      },
      {
        "x": "Subway",
        "y": 72369
      },
      {
        "x": "Bus",
        "y": 22311
      },
      {
        "x": "Car",
        "y": -63074
      },
      {
        "x": "Boat",
        "y": -77718
      },
      {
        "x": "Moto",
        "y": 8085
      },
      {
        "x": "Moped",
        "y": 77193
      },
      {
        "x": "Bicycle",
        "y": 39073
      },
      {
        "x": "Others",
        "y": 3292
      }
    ]
  },
  {
    "id": "Norway",
    "data": [
      {
        "x": "Train",
        "y": 12390
      },
      {
        "x": "Subway",
        "y": -6194
      },
      {
        "x": "Bus",
        "y": -82639
      },
      {
        "x": "Car",
        "y": 86763
      },
      {
        "x": "Boat",
        "y": 81945
      },
      {
        "x": "Moto",
        "y": -88172
      },
      {
        "x": "Moped",
        "y": 59464
      },
      {
        "x": "Bicycle",
        "y": 51254
      },
      {
        "x": "Others",
        "y": -21814
      }
    ]
  },
  {
    "id": "Iceland",
    "data": [
      {
        "x": "Train",
        "y": -56030
      },
      {
        "x": "Subway",
        "y": -47934
      },
      {
        "x": "Bus",
        "y": 72383
      },
      {
        "x": "Car",
        "y": -97322
      },
      {
        "x": "Boat",
        "y": 6377
      },
      {
        "x": "Moto",
        "y": -22337
      },
      {
        "x": "Moped",
        "y": -83894
      },
      {
        "x": "Bicycle",
        "y": -57687
      },
      {
        "x": "Others",
        "y": -35826
      }
    ]
  },
  {
    "id": "UK",
    "data": [
      {
        "x": "Train",
        "y": -17805
      },
      {
        "x": "Subway",
        "y": -48920
      },
      {
        "x": "Bus",
        "y": -66921
      },
      {
        "x": "Car",
        "y": 71653
      },
      {
        "x": "Boat",
        "y": -95883
      },
      {
        "x": "Moto",
        "y": 24555
      },
      {
        "x": "Moped",
        "y": 28251
      },
      {
        "x": "Bicycle",
        "y": 94634
      },
      {
        "x": "Others",
        "y": 14442
      }
    ]
  },
  {
    "id": "Vietnam",
    "data": [
      {
        "x": "Train",
        "y": 29156
      },
      {
        "x": "Subway",
        "y": -6903
      },
      {
        "x": "Bus",
        "y": 697
      },
      {
        "x": "Car",
        "y": 76660
      },
      {
        "x": "Boat",
        "y": 41519
      },
      {
        "x": "Moto",
        "y": 3167
      },
      {
        "x": "Moped",
        "y": -4368
      },
      {
        "x": "Bicycle",
        "y": -4216
      },
      {
        "x": "Others",
        "y": -44336
      }
    ]
  }
]
const dline = [
  {
    "id": "japan",
    "color": "hsl(302, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 202
      },
      {
        "x": "helicopter",
        "y": 283
      },
      {
        "x": "boat",
        "y": 114
      },
      {
        "x": "train",
        "y": 124
      },
      {
        "x": "subway",
        "y": 112
      },
      {
        "x": "bus",
        "y": 272
      },
      {
        "x": "car",
        "y": 126
      },
      {
        "x": "moto",
        "y": 263
      },
      {
        "x": "bicycle",
        "y": 236
      },
      {
        "x": "horse",
        "y": 74
      },
      {
        "x": "skateboard",
        "y": 59
      },
      {
        "x": "others",
        "y": 281
      }
    ]
  },
  {
    "id": "france",
    "color": "hsl(56, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 220
      },
      {
        "x": "helicopter",
        "y": 155
      },
      {
        "x": "boat",
        "y": 291
      },
      {
        "x": "train",
        "y": 57
      },
      {
        "x": "subway",
        "y": 206
      },
      {
        "x": "bus",
        "y": 163
      },
      {
        "x": "car",
        "y": 49
      },
      {
        "x": "moto",
        "y": 29
      },
      {
        "x": "bicycle",
        "y": 289
      },
      {
        "x": "horse",
        "y": 231
      },
      {
        "x": "skateboard",
        "y": 80
      },
      {
        "x": "others",
        "y": 108
      }
    ]
  },
  {
    "id": "us",
    "color": "hsl(55, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 72
      },
      {
        "x": "helicopter",
        "y": 54
      },
      {
        "x": "boat",
        "y": 99
      },
      {
        "x": "train",
        "y": 286
      },
      {
        "x": "subway",
        "y": 102
      },
      {
        "x": "bus",
        "y": 43
      },
      {
        "x": "car",
        "y": 250
      },
      {
        "x": "moto",
        "y": 255
      },
      {
        "x": "bicycle",
        "y": 298
      },
      {
        "x": "horse",
        "y": 110
      },
      {
        "x": "skateboard",
        "y": 7
      },
      {
        "x": "others",
        "y": 211
      }
    ]
  },
  {
    "id": "germany",
    "color": "hsl(230, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 155
      },
      {
        "x": "helicopter",
        "y": 64
      },
      {
        "x": "boat",
        "y": 278
      },
      {
        "x": "train",
        "y": 15
      },
      {
        "x": "subway",
        "y": 155
      },
      {
        "x": "bus",
        "y": 212
      },
      {
        "x": "car",
        "y": 218
      },
      {
        "x": "moto",
        "y": 293
      },
      {
        "x": "bicycle",
        "y": 93
      },
      {
        "x": "horse",
        "y": 191
      },
      {
        "x": "skateboard",
        "y": 44
      },
      {
        "x": "others",
        "y": 276
      }
    ]
  },
  {
    "id": "norway",
    "color": "hsl(68, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 93
      },
      {
        "x": "helicopter",
        "y": 64
      },
      {
        "x": "boat",
        "y": 70
      },
      {
        "x": "train",
        "y": 59
      },
      {
        "x": "subway",
        "y": 253
      },
      {
        "x": "bus",
        "y": 128
      },
      {
        "x": "car",
        "y": 147
      },
      {
        "x": "moto",
        "y": 75
      },
      {
        "x": "bicycle",
        "y": 108
      },
      {
        "x": "horse",
        "y": 73
      },
      {
        "x": "skateboard",
        "y": 261
      },
      {
        "x": "others",
        "y": 75
      }
    ]
  }
]
const dmarimekko = [
  {
    "statement": "it's good",
    "participation": 21,
    "stronglyAgree": 24,
    "agree": 13,
    "disagree": 8,
    "stronglyDisagree": 29
  },
  {
    "statement": "it's sweet",
    "participation": 7,
    "stronglyAgree": 15,
    "agree": 25,
    "disagree": 8,
    "stronglyDisagree": 11
  },
  {
    "statement": "it's spicy",
    "participation": 32,
    "stronglyAgree": 28,
    "agree": 17,
    "disagree": 22,
    "stronglyDisagree": 1
  },
  {
    "statement": "worth eating",
    "participation": 15,
    "stronglyAgree": 30,
    "agree": 4,
    "disagree": 32,
    "stronglyDisagree": 1
  },
  {
    "statement": "worth buying",
    "participation": 4,
    "stronglyAgree": 1,
    "agree": 23,
    "disagree": 0,
    "stronglyDisagree": 29
  }
]
const dradar = [
  {
    "taste": "fruity",
    "chardonay": 67,
    "carmenere": 35,
    "syrah": 58
  },
  {
    "taste": "bitter",
    "chardonay": 44,
    "carmenere": 97,
    "syrah": 54
  },
  {
    "taste": "heavy",
    "chardonay": 26,
    "carmenere": 92,
    "syrah": 96
  },
  {
    "taste": "strong",
    "chardonay": 80,
    "carmenere": 89,
    "syrah": 100
  },
  {
    "taste": "sunny",
    "chardonay": 41,
    "carmenere": 28,
    "syrah": 29
  }
]

const dswarm = [
  {
    "id": "0.0",
    "group": "group A",
    "price": 125,
    "volume": 11
  },
  {
    "id": "0.1",
    "group": "group A",
    "price": 57,
    "volume": 18
  },
  {
    "id": "0.2",
    "group": "group A",
    "price": 125,
    "volume": 7
  },
  {
    "id": "0.3",
    "group": "group A",
    "price": 125,
    "volume": 10
  },
  {
    "id": "0.4",
    "group": "group A",
    "price": 356,
    "volume": 19
  },
  {
    "id": "0.5",
    "group": "group A",
    "price": 141,
    "volume": 20
  },
  {
    "id": "0.6",
    "group": "group A",
    "price": 299,
    "volume": 16
  },
  {
    "id": "0.7",
    "group": "group A",
    "price": 158,
    "volume": 15
  },
  {
    "id": "0.8",
    "group": "group A",
    "price": 167,
    "volume": 6
  },
  {
    "id": "0.9",
    "group": "group A",
    "price": 443,
    "volume": 15
  },
  {
    "id": "0.10",
    "group": "group A",
    "price": 145,
    "volume": 18
  },
  {
    "id": "0.11",
    "group": "group A",
    "price": 234,
    "volume": 20
  },
  {
    "id": "0.12",
    "group": "group A",
    "price": 477,
    "volume": 14
  },
  {
    "id": "0.13",
    "group": "group A",
    "price": 412,
    "volume": 9
  },
  {
    "id": "0.14",
    "group": "group A",
    "price": 1,
    "volume": 5
  },
  {
    "id": "0.15",
    "group": "group A",
    "price": 150,
    "volume": 7
  },
  {
    "id": "0.16",
    "group": "group A",
    "price": 267,
    "volume": 6
  },
  {
    "id": "0.17",
    "group": "group A",
    "price": 75,
    "volume": 16
  },
  {
    "id": "0.18",
    "group": "group A",
    "price": 372,
    "volume": 7
  },
  {
    "id": "0.19",
    "group": "group A",
    "price": 7,
    "volume": 5
  },
  {
    "id": "0.20",
    "group": "group A",
    "price": 391,
    "volume": 9
  },
  {
    "id": "0.21",
    "group": "group A",
    "price": 306,
    "volume": 16
  },
  {
    "id": "0.22",
    "group": "group A",
    "price": 86,
    "volume": 5
  },
  {
    "id": "0.23",
    "group": "group A",
    "price": 349,
    "volume": 14
  },
  {
    "id": "0.24",
    "group": "group A",
    "price": 225,
    "volume": 18
  },
  {
    "id": "0.25",
    "group": "group A",
    "price": 190,
    "volume": 6
  },
  {
    "id": "0.26",
    "group": "group A",
    "price": 498,
    "volume": 17
  },
  {
    "id": "0.27",
    "group": "group A",
    "price": 151,
    "volume": 6
  },
  {
    "id": "0.28",
    "group": "group A",
    "price": 177,
    "volume": 9
  },
  {
    "id": "0.29",
    "group": "group A",
    "price": 131,
    "volume": 7
  },
  {
    "id": "0.30",
    "group": "group A",
    "price": 481,
    "volume": 11
  },
  {
    "id": "0.31",
    "group": "group A",
    "price": 281,
    "volume": 13
  },
  {
    "id": "0.32",
    "group": "group A",
    "price": 473,
    "volume": 7
  },
  {
    "id": "0.33",
    "group": "group A",
    "price": 422,
    "volume": 16
  },
  {
    "id": "0.34",
    "group": "group A",
    "price": 117,
    "volume": 13
  },
  {
    "id": "0.35",
    "group": "group A",
    "price": 51,
    "volume": 10
  },
  {
    "id": "0.36",
    "group": "group A",
    "price": 176,
    "volume": 16
  },
  {
    "id": "0.37",
    "group": "group A",
    "price": 412,
    "volume": 5
  },
  {
    "id": "0.38",
    "group": "group A",
    "price": 460,
    "volume": 13
  },
  {
    "id": "0.39",
    "group": "group A",
    "price": 413,
    "volume": 19
  },
  {
    "id": "0.40",
    "group": "group A",
    "price": 128,
    "volume": 6
  },
  {
    "id": "0.41",
    "group": "group A",
    "price": 339,
    "volume": 20
  },
  {
    "id": "0.42",
    "group": "group A",
    "price": 24,
    "volume": 4
  },
  {
    "id": "0.43",
    "group": "group A",
    "price": 189,
    "volume": 12
  },
  {
    "id": "0.44",
    "group": "group A",
    "price": 426,
    "volume": 19
  },
  {
    "id": "0.45",
    "group": "group A",
    "price": 364,
    "volume": 15
  },
  {
    "id": "0.46",
    "group": "group A",
    "price": 364,
    "volume": 13
  },
  {
    "id": "0.47",
    "group": "group A",
    "price": 472,
    "volume": 10
  },
  {
    "id": "0.48",
    "group": "group A",
    "price": 203,
    "volume": 18
  },
  {
    "id": "0.49",
    "group": "group A",
    "price": 62,
    "volume": 14
  },
  {
    "id": "0.50",
    "group": "group A",
    "price": 296,
    "volume": 17
  },
  {
    "id": "0.51",
    "group": "group A",
    "price": 406,
    "volume": 11
  },
  {
    "id": "0.52",
    "group": "group A",
    "price": 34,
    "volume": 14
  },
  {
    "id": "0.53",
    "group": "group A",
    "price": 442,
    "volume": 13
  },
  {
    "id": "1.0",
    "group": "group B",
    "price": 349,
    "volume": 20
  },
  {
    "id": "1.1",
    "group": "group B",
    "price": 262,
    "volume": 4
  },
  {
    "id": "1.2",
    "group": "group B",
    "price": 216,
    "volume": 14
  },
  {
    "id": "1.3",
    "group": "group B",
    "price": 404,
    "volume": 7
  },
  {
    "id": "1.4",
    "group": "group B",
    "price": 435,
    "volume": 10
  },
  {
    "id": "1.5",
    "group": "group B",
    "price": 379,
    "volume": 13
  },
  {
    "id": "1.6",
    "group": "group B",
    "price": 295,
    "volume": 10
  },
  {
    "id": "1.7",
    "group": "group B",
    "price": 472,
    "volume": 6
  },
  {
    "id": "1.8",
    "group": "group B",
    "price": 416,
    "volume": 13
  },
  {
    "id": "1.9",
    "group": "group B",
    "price": 475,
    "volume": 10
  },
  {
    "id": "1.10",
    "group": "group B",
    "price": 200,
    "volume": 4
  },
  {
    "id": "1.11",
    "group": "group B",
    "price": 335,
    "volume": 7
  },
  {
    "id": "1.12",
    "group": "group B",
    "price": 213,
    "volume": 20
  },
  {
    "id": "1.13",
    "group": "group B",
    "price": 399,
    "volume": 10
  },
  {
    "id": "1.14",
    "group": "group B",
    "price": 82,
    "volume": 8
  },
  {
    "id": "1.15",
    "group": "group B",
    "price": 209,
    "volume": 12
  },
  {
    "id": "1.16",
    "group": "group B",
    "price": 359,
    "volume": 11
  },
  {
    "id": "1.17",
    "group": "group B",
    "price": 224,
    "volume": 18
  },
  {
    "id": "1.18",
    "group": "group B",
    "price": 13,
    "volume": 17
  },
  {
    "id": "1.19",
    "group": "group B",
    "price": 84,
    "volume": 10
  },
  {
    "id": "1.20",
    "group": "group B",
    "price": 124,
    "volume": 19
  },
  {
    "id": "1.21",
    "group": "group B",
    "price": 422,
    "volume": 11
  },
  {
    "id": "1.22",
    "group": "group B",
    "price": 354,
    "volume": 9
  },
  {
    "id": "1.23",
    "group": "group B",
    "price": 164,
    "volume": 4
  },
  {
    "id": "1.24",
    "group": "group B",
    "price": 309,
    "volume": 18
  },
  {
    "id": "1.25",
    "group": "group B",
    "price": 110,
    "volume": 8
  },
  {
    "id": "1.26",
    "group": "group B",
    "price": 82,
    "volume": 13
  },
  {
    "id": "1.27",
    "group": "group B",
    "price": 260,
    "volume": 5
  },
  {
    "id": "1.28",
    "group": "group B",
    "price": 355,
    "volume": 13
  },
  {
    "id": "1.29",
    "group": "group B",
    "price": 272,
    "volume": 11
  },
  {
    "id": "1.30",
    "group": "group B",
    "price": 63,
    "volume": 6
  },
  {
    "id": "1.31",
    "group": "group B",
    "price": 398,
    "volume": 7
  },
  {
    "id": "1.32",
    "group": "group B",
    "price": 457,
    "volume": 20
  },
  {
    "id": "1.33",
    "group": "group B",
    "price": 487,
    "volume": 15
  },
  {
    "id": "1.34",
    "group": "group B",
    "price": 269,
    "volume": 13
  },
  {
    "id": "1.35",
    "group": "group B",
    "price": 174,
    "volume": 8
  },
  {
    "id": "1.36",
    "group": "group B",
    "price": 128,
    "volume": 12
  },
  {
    "id": "1.37",
    "group": "group B",
    "price": 208,
    "volume": 6
  },
  {
    "id": "1.38",
    "group": "group B",
    "price": 64,
    "volume": 19
  },
  {
    "id": "1.39",
    "group": "group B",
    "price": 98,
    "volume": 14
  },
  {
    "id": "1.40",
    "group": "group B",
    "price": 226,
    "volume": 6
  },
  {
    "id": "1.41",
    "group": "group B",
    "price": 345,
    "volume": 11
  },
  {
    "id": "1.42",
    "group": "group B",
    "price": 235,
    "volume": 17
  },
  {
    "id": "1.43",
    "group": "group B",
    "price": 86,
    "volume": 11
  },
  {
    "id": "1.44",
    "group": "group B",
    "price": 235,
    "volume": 13
  },
  {
    "id": "1.45",
    "group": "group B",
    "price": 219,
    "volume": 7
  },
  {
    "id": "1.46",
    "group": "group B",
    "price": 316,
    "volume": 16
  },
  {
    "id": "1.47",
    "group": "group B",
    "price": 396,
    "volume": 14
  },
  {
    "id": "1.48",
    "group": "group B",
    "price": 11,
    "volume": 13
  },
  {
    "id": "1.49",
    "group": "group B",
    "price": 238,
    "volume": 18
  },
  {
    "id": "1.50",
    "group": "group B",
    "price": 317,
    "volume": 17
  },
  {
    "id": "1.51",
    "group": "group B",
    "price": 288,
    "volume": 12
  },
  {
    "id": "1.52",
    "group": "group B",
    "price": 363,
    "volume": 14
  },
  {
    "id": "1.53",
    "group": "group B",
    "price": 198,
    "volume": 10
  },
  {
    "id": "1.54",
    "group": "group B",
    "price": 372,
    "volume": 5
  },
  {
    "id": "1.55",
    "group": "group B",
    "price": 49,
    "volume": 17
  },
  {
    "id": "1.56",
    "group": "group B",
    "price": 197,
    "volume": 20
  },
  {
    "id": "1.57",
    "group": "group B",
    "price": 7,
    "volume": 8
  },
  {
    "id": "1.58",
    "group": "group B",
    "price": 429,
    "volume": 10
  },
  {
    "id": "1.59",
    "group": "group B",
    "price": 153,
    "volume": 19
  },
  {
    "id": "1.60",
    "group": "group B",
    "price": 147,
    "volume": 11
  },
  {
    "id": "1.61",
    "group": "group B",
    "price": 19,
    "volume": 16
  },
  {
    "id": "1.62",
    "group": "group B",
    "price": 179,
    "volume": 6
  },
  {
    "id": "1.63",
    "group": "group B",
    "price": 343,
    "volume": 16
  },
  {
    "id": "1.64",
    "group": "group B",
    "price": 197,
    "volume": 10
  },
  {
    "id": "1.65",
    "group": "group B",
    "price": 192,
    "volume": 4
  },
  {
    "id": "1.66",
    "group": "group B",
    "price": 194,
    "volume": 11
  },
  {
    "id": "1.67",
    "group": "group B",
    "price": 219,
    "volume": 7
  },
  {
    "id": "1.68",
    "group": "group B",
    "price": 81,
    "volume": 12
  },
  {
    "id": "1.69",
    "group": "group B",
    "price": 188,
    "volume": 19
  },
  {
    "id": "1.70",
    "group": "group B",
    "price": 185,
    "volume": 16
  },
  {
    "id": "1.71",
    "group": "group B",
    "price": 40,
    "volume": 7
  },
  {
    "id": "1.72",
    "group": "group B",
    "price": 394,
    "volume": 16
  },
  {
    "id": "1.73",
    "group": "group B",
    "price": 492,
    "volume": 10
  },
  {
    "id": "2.0",
    "group": "group C",
    "price": 235,
    "volume": 6
  },
  {
    "id": "2.1",
    "group": "group C",
    "price": 61,
    "volume": 18
  },
  {
    "id": "2.2",
    "group": "group C",
    "price": 299,
    "volume": 15
  },
  {
    "id": "2.3",
    "group": "group C",
    "price": 19,
    "volume": 5
  },
  {
    "id": "2.4",
    "group": "group C",
    "price": 341,
    "volume": 7
  },
  {
    "id": "2.5",
    "group": "group C",
    "price": 134,
    "volume": 8
  },
  {
    "id": "2.6",
    "group": "group C",
    "price": 181,
    "volume": 6
  },
  {
    "id": "2.7",
    "group": "group C",
    "price": 200,
    "volume": 19
  },
  {
    "id": "2.8",
    "group": "group C",
    "price": 183,
    "volume": 5
  },
  {
    "id": "2.9",
    "group": "group C",
    "price": 357,
    "volume": 10
  },
  {
    "id": "2.10",
    "group": "group C",
    "price": 172,
    "volume": 13
  },
  {
    "id": "2.11",
    "group": "group C",
    "price": 452,
    "volume": 4
  },
  {
    "id": "2.12",
    "group": "group C",
    "price": 181,
    "volume": 20
  },
  {
    "id": "2.13",
    "group": "group C",
    "price": 111,
    "volume": 10
  },
  {
    "id": "2.14",
    "group": "group C",
    "price": 62,
    "volume": 18
  },
  {
    "id": "2.15",
    "group": "group C",
    "price": 81,
    "volume": 10
  },
  {
    "id": "2.16",
    "group": "group C",
    "price": 286,
    "volume": 15
  },
  {
    "id": "2.17",
    "group": "group C",
    "price": 339,
    "volume": 14
  },
  {
    "id": "2.18",
    "group": "group C",
    "price": 375,
    "volume": 16
  },
  {
    "id": "2.19",
    "group": "group C",
    "price": 34,
    "volume": 19
  },
  {
    "id": "2.20",
    "group": "group C",
    "price": 7,
    "volume": 20
  },
  {
    "id": "2.21",
    "group": "group C",
    "price": 44,
    "volume": 18
  },
  {
    "id": "2.22",
    "group": "group C",
    "price": 237,
    "volume": 15
  },
  {
    "id": "2.23",
    "group": "group C",
    "price": 364,
    "volume": 8
  },
  {
    "id": "2.24",
    "group": "group C",
    "price": 386,
    "volume": 19
  },
  {
    "id": "2.25",
    "group": "group C",
    "price": 154,
    "volume": 17
  },
  {
    "id": "2.26",
    "group": "group C",
    "price": 55,
    "volume": 9
  },
  {
    "id": "2.27",
    "group": "group C",
    "price": 191,
    "volume": 9
  },
  {
    "id": "2.28",
    "group": "group C",
    "price": 169,
    "volume": 7
  },
  {
    "id": "2.29",
    "group": "group C",
    "price": 224,
    "volume": 10
  },
  {
    "id": "2.30",
    "group": "group C",
    "price": 295,
    "volume": 10
  },
  {
    "id": "2.31",
    "group": "group C",
    "price": 184,
    "volume": 8
  },
  {
    "id": "2.32",
    "group": "group C",
    "price": 423,
    "volume": 8
  },
  {
    "id": "2.33",
    "group": "group C",
    "price": 435,
    "volume": 5
  },
  {
    "id": "2.34",
    "group": "group C",
    "price": 389,
    "volume": 17
  },
  {
    "id": "2.35",
    "group": "group C",
    "price": 457,
    "volume": 19
  },
  {
    "id": "2.36",
    "group": "group C",
    "price": 116,
    "volume": 14
  },
  {
    "id": "2.37",
    "group": "group C",
    "price": 179,
    "volume": 15
  },
  {
    "id": "2.38",
    "group": "group C",
    "price": 457,
    "volume": 20
  },
  {
    "id": "2.39",
    "group": "group C",
    "price": 174,
    "volume": 10
  },
  {
    "id": "2.40",
    "group": "group C",
    "price": 360,
    "volume": 17
  },
  {
    "id": "2.41",
    "group": "group C",
    "price": 198,
    "volume": 5
  },
  {
    "id": "2.42",
    "group": "group C",
    "price": 322,
    "volume": 16
  },
  {
    "id": "2.43",
    "group": "group C",
    "price": 373,
    "volume": 12
  },
  {
    "id": "2.44",
    "group": "group C",
    "price": 168,
    "volume": 18
  },
  {
    "id": "2.45",
    "group": "group C",
    "price": 332,
    "volume": 9
  },
  {
    "id": "2.46",
    "group": "group C",
    "price": 230,
    "volume": 20
  },
  {
    "id": "2.47",
    "group": "group C",
    "price": 445,
    "volume": 10
  },
  {
    "id": "2.48",
    "group": "group C",
    "price": 352,
    "volume": 13
  },
  {
    "id": "2.49",
    "group": "group C",
    "price": 20,
    "volume": 10
  },
  {
    "id": "2.50",
    "group": "group C",
    "price": 233,
    "volume": 14
  },
  {
    "id": "2.51",
    "group": "group C",
    "price": 416,
    "volume": 18
  },
  {
    "id": "2.52",
    "group": "group C",
    "price": 82,
    "volume": 10
  },
  {
    "id": "2.53",
    "group": "group C",
    "price": 445,
    "volume": 18
  },
  {
    "id": "2.54",
    "group": "group C",
    "price": 418,
    "volume": 9
  },
  {
    "id": "2.55",
    "group": "group C",
    "price": 244,
    "volume": 14
  },
  {
    "id": "2.56",
    "group": "group C",
    "price": 427,
    "volume": 19
  },
  {
    "id": "2.57",
    "group": "group C",
    "price": 108,
    "volume": 13
  },
  {
    "id": "2.58",
    "group": "group C",
    "price": 138,
    "volume": 11
  },
  {
    "id": "2.59",
    "group": "group C",
    "price": 281,
    "volume": 7
  },
  {
    "id": "2.60",
    "group": "group C",
    "price": 379,
    "volume": 12
  },
  {
    "id": "2.61",
    "group": "group C",
    "price": 245,
    "volume": 12
  },
  {
    "id": "2.62",
    "group": "group C",
    "price": 35,
    "volume": 11
  },
  {
    "id": "2.63",
    "group": "group C",
    "price": 464,
    "volume": 5
  },
  {
    "id": "2.64",
    "group": "group C",
    "price": 473,
    "volume": 4
  },
  {
    "id": "2.65",
    "group": "group C",
    "price": 103,
    "volume": 17
  },
  {
    "id": "2.66",
    "group": "group C",
    "price": 133,
    "volume": 17
  },
  {
    "id": "2.67",
    "group": "group C",
    "price": 474,
    "volume": 12
  },
  {
    "id": "2.68",
    "group": "group C",
    "price": 374,
    "volume": 20
  },
  {
    "id": "2.69",
    "group": "group C",
    "price": 350,
    "volume": 10
  },
  {
    "id": "2.70",
    "group": "group C",
    "price": 228,
    "volume": 7
  },
  {
    "id": "2.71",
    "group": "group C",
    "price": 67,
    "volume": 15
  },
  {
    "id": "2.72",
    "group": "group C",
    "price": 434,
    "volume": 15
  },
  {
    "id": "2.73",
    "group": "group C",
    "price": 278,
    "volume": 9
  },
  {
    "id": "2.74",
    "group": "group C",
    "price": 47,
    "volume": 20
  }
]
const dscatter = [
  {
    "id": "group A",
    "data": [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 41,
        "y": 63
      },
      {
        "x": 39,
        "y": 67
      },
      {
        "x": 36,
        "y": 5
      },
      {
        "x": 95,
        "y": 20
      },
      {
        "x": 51,
        "y": 115
      },
      {
        "x": 51,
        "y": 17
      },
      {
        "x": 10,
        "y": 116
      },
      {
        "x": 3,
        "y": 16
      },
      {
        "x": 98,
        "y": 91
      },
      {
        "x": 29,
        "y": 97
      },
      {
        "x": 67,
        "y": 70
      },
      {
        "x": 26,
        "y": 71
      },
      {
        "x": 0,
        "y": 34
      },
      {
        "x": 7,
        "y": 42
      },
      {
        "x": 91,
        "y": 42
      },
      {
        "x": 61,
        "y": 53
      },
      {
        "x": 28,
        "y": 55
      },
      {
        "x": 86,
        "y": 62
      },
      {
        "x": 98,
        "y": 117
      },
      {
        "x": 22,
        "y": 105
      },
      {
        "x": 94,
        "y": 35
      },
      {
        "x": 58,
        "y": 41
      },
      {
        "x": 56,
        "y": 95
      },
      {
        "x": 22,
        "y": 32
      },
      {
        "x": 82,
        "y": 94
      },
      {
        "x": 26,
        "y": 47
      },
      {
        "x": 24,
        "y": 37
      },
      {
        "x": 8,
        "y": 87
      },
      {
        "x": 49,
        "y": 25
      },
      {
        "x": 45,
        "y": 72
      },
      {
        "x": 51,
        "y": 35
      },
      {
        "x": 82,
        "y": 2
      },
      {
        "x": 96,
        "y": 17
      },
      {
        "x": 9,
        "y": 13
      },
      {
        "x": 40,
        "y": 50
      },
      {
        "x": 67,
        "y": 107
      },
      {
        "x": 98,
        "y": 17
      },
      {
        "x": 63,
        "y": 73
      },
      {
        "x": 22,
        "y": 72
      },
      {
        "x": 25,
        "y": 25
      },
      {
        "x": 92,
        "y": 66
      },
      {
        "x": 66,
        "y": 10
      },
      {
        "x": 45,
        "y": 81
      },
      {
        "x": 38,
        "y": 82
      },
      {
        "x": 71,
        "y": 38
      },
      {
        "x": 35,
        "y": 98
      },
      {
        "x": 65,
        "y": 112
      },
      {
        "x": 44,
        "y": 74
      },
      {
        "x": 86,
        "y": 15
      }
    ]
  },
  {
    "id": "group B",
    "data": [
      {
        "x": 31,
        "y": 56
      },
      {
        "x": 50,
        "y": 63
      },
      {
        "x": 55,
        "y": 112
      },
      {
        "x": 30,
        "y": 100
      },
      {
        "x": 1,
        "y": 25
      },
      {
        "x": 99,
        "y": 10
      },
      {
        "x": 71,
        "y": 103
      },
      {
        "x": 75,
        "y": 112
      },
      {
        "x": 70,
        "y": 86
      },
      {
        "x": 28,
        "y": 45
      },
      {
        "x": 7,
        "y": 114
      },
      {
        "x": 72,
        "y": 41
      },
      {
        "x": 85,
        "y": 116
      },
      {
        "x": 97,
        "y": 59
      },
      {
        "x": 7,
        "y": 22
      },
      {
        "x": 2,
        "y": 116
      },
      {
        "x": 34,
        "y": 23
      },
      {
        "x": 85,
        "y": 65
      },
      {
        "x": 45,
        "y": 114
      },
      {
        "x": 12,
        "y": 46
      },
      {
        "x": 21,
        "y": 41
      },
      {
        "x": 56,
        "y": 115
      },
      {
        "x": 64,
        "y": 46
      },
      {
        "x": 89,
        "y": 93
      },
      {
        "x": 92,
        "y": 32
      },
      {
        "x": 65,
        "y": 89
      },
      {
        "x": 82,
        "y": 44
      },
      {
        "x": 94,
        "y": 120
      },
      {
        "x": 23,
        "y": 5
      },
      {
        "x": 40,
        "y": 44
      },
      {
        "x": 81,
        "y": 50
      },
      {
        "x": 48,
        "y": 50
      },
      {
        "x": 77,
        "y": 32
      },
      {
        "x": 34,
        "y": 22
      },
      {
        "x": 86,
        "y": 58
      },
      {
        "x": 42,
        "y": 14
      },
      {
        "x": 64,
        "y": 21
      },
      {
        "x": 42,
        "y": 30
      },
      {
        "x": 47,
        "y": 43
      },
      {
        "x": 46,
        "y": 29
      },
      {
        "x": 14,
        "y": 42
      },
      {
        "x": 67,
        "y": 3
      },
      {
        "x": 23,
        "y": 66
      },
      {
        "x": 47,
        "y": 24
      },
      {
        "x": 19,
        "y": 20
      },
      {
        "x": 85,
        "y": 74
      },
      {
        "x": 60,
        "y": 10
      },
      {
        "x": 62,
        "y": 90
      },
      {
        "x": 84,
        "y": 85
      },
      {
        "x": 93,
        "y": 16
      }
    ]
  },
  {
    "id": "group C",
    "data": [
      {
        "x": 65,
        "y": 48
      },
      {
        "x": 69,
        "y": 28
      },
      {
        "x": 31,
        "y": 31
      },
      {
        "x": 94,
        "y": 3
      },
      {
        "x": 8,
        "y": 66
      },
      {
        "x": 53,
        "y": 112
      },
      {
        "x": 2,
        "y": 106
      },
      {
        "x": 100,
        "y": 61
      },
      {
        "x": 25,
        "y": 108
      },
      {
        "x": 56,
        "y": 51
      },
      {
        "x": 21,
        "y": 21
      },
      {
        "x": 16,
        "y": 67
      },
      {
        "x": 96,
        "y": 45
      },
      {
        "x": 42,
        "y": 51
      },
      {
        "x": 93,
        "y": 24
      },
      {
        "x": 72,
        "y": 17
      },
      {
        "x": 18,
        "y": 114
      },
      {
        "x": 14,
        "y": 36
      },
      {
        "x": 31,
        "y": 79
      },
      {
        "x": 68,
        "y": 118
      },
      {
        "x": 62,
        "y": 116
      },
      {
        "x": 99,
        "y": 28
      },
      {
        "x": 31,
        "y": 52
      },
      {
        "x": 60,
        "y": 45
      },
      {
        "x": 59,
        "y": 29
      },
      {
        "x": 35,
        "y": 56
      },
      {
        "x": 76,
        "y": 3
      },
      {
        "x": 44,
        "y": 39
      },
      {
        "x": 50,
        "y": 62
      },
      {
        "x": 55,
        "y": 112
      },
      {
        "x": 17,
        "y": 3
      },
      {
        "x": 93,
        "y": 82
      },
      {
        "x": 75,
        "y": 52
      },
      {
        "x": 18,
        "y": 16
      },
      {
        "x": 29,
        "y": 80
      },
      {
        "x": 44,
        "y": 91
      },
      {
        "x": 80,
        "y": 97
      },
      {
        "x": 99,
        "y": 37
      },
      {
        "x": 46,
        "y": 46
      },
      {
        "x": 65,
        "y": 113
      },
      {
        "x": 86,
        "y": 48
      },
      {
        "x": 100,
        "y": 89
      },
      {
        "x": 2,
        "y": 43
      },
      {
        "x": 28,
        "y": 15
      },
      {
        "x": 32,
        "y": 81
      },
      {
        "x": 52,
        "y": 36
      },
      {
        "x": 75,
        "y": 16
      },
      {
        "x": 47,
        "y": 102
      },
      {
        "x": 53,
        "y": 83
      },
      {
        "x": 39,
        "y": 65
      }
    ]
  },
  {
    "id": "group D",
    "data": [
      {
        "x": 50,
        "y": 68
      },
      {
        "x": 25,
        "y": 14
      },
      {
        "x": 40,
        "y": 113
      },
      {
        "x": 9,
        "y": 67
      },
      {
        "x": 93,
        "y": 104
      },
      {
        "x": 40,
        "y": 106
      },
      {
        "x": 49,
        "y": 16
      },
      {
        "x": 32,
        "y": 3
      },
      {
        "x": 81,
        "y": 32
      },
      {
        "x": 52,
        "y": 26
      },
      {
        "x": 72,
        "y": 73
      },
      {
        "x": 85,
        "y": 17
      },
      {
        "x": 76,
        "y": 77
      },
      {
        "x": 83,
        "y": 23
      },
      {
        "x": 26,
        "y": 113
      },
      {
        "x": 5,
        "y": 80
      },
      {
        "x": 59,
        "y": 34
      },
      {
        "x": 56,
        "y": 41
      },
      {
        "x": 51,
        "y": 26
      },
      {
        "x": 39,
        "y": 13
      },
      {
        "x": 55,
        "y": 43
      },
      {
        "x": 90,
        "y": 41
      },
      {
        "x": 95,
        "y": 79
      },
      {
        "x": 40,
        "y": 0
      },
      {
        "x": 65,
        "y": 58
      },
      {
        "x": 15,
        "y": 73
      },
      {
        "x": 25,
        "y": 70
      },
      {
        "x": 60,
        "y": 70
      },
      {
        "x": 23,
        "y": 102
      },
      {
        "x": 92,
        "y": 36
      },
      {
        "x": 19,
        "y": 48
      },
      {
        "x": 95,
        "y": 7
      },
      {
        "x": 72,
        "y": 79
      },
      {
        "x": 85,
        "y": 105
      },
      {
        "x": 78,
        "y": 111
      },
      {
        "x": 15,
        "y": 43
      },
      {
        "x": 84,
        "y": 14
      },
      {
        "x": 38,
        "y": 44
      },
      {
        "x": 61,
        "y": 112
      },
      {
        "x": 27,
        "y": 12
      },
      {
        "x": 3,
        "y": 113
      },
      {
        "x": 4,
        "y": 8
      },
      {
        "x": 94,
        "y": 104
      },
      {
        "x": 90,
        "y": 101
      },
      {
        "x": 80,
        "y": 114
      },
      {
        "x": 14,
        "y": 58
      },
      {
        "x": 93,
        "y": 100
      },
      {
        "x": 19,
        "y": 96
      },
      {
        "x": 55,
        "y": 29
      },
      {
        "x": 8,
        "y": 108
      }
    ]
  },
  {
    "id": "group E",
    "data": [
      {
        "x": 84,
        "y": 72
      },
      {
        "x": 2,
        "y": 113
      },
      {
        "x": 51,
        "y": 83
      },
      {
        "x": 69,
        "y": 54
      },
      {
        "x": 44,
        "y": 31
      },
      {
        "x": 28,
        "y": 36
      },
      {
        "x": 73,
        "y": 64
      },
      {
        "x": 80,
        "y": 97
      },
      {
        "x": 21,
        "y": 41
      },
      {
        "x": 40,
        "y": 117
      },
      {
        "x": 49,
        "y": 65
      },
      {
        "x": 4,
        "y": 20
      },
      {
        "x": 80,
        "y": 66
      },
      {
        "x": 4,
        "y": 115
      },
      {
        "x": 52,
        "y": 24
      },
      {
        "x": 60,
        "y": 25
      },
      {
        "x": 53,
        "y": 93
      },
      {
        "x": 2,
        "y": 52
      },
      {
        "x": 2,
        "y": 28
      },
      {
        "x": 92,
        "y": 60
      },
      {
        "x": 4,
        "y": 34
      },
      {
        "x": 57,
        "y": 117
      },
      {
        "x": 8,
        "y": 112
      },
      {
        "x": 86,
        "y": 22
      },
      {
        "x": 24,
        "y": 108
      },
      {
        "x": 30,
        "y": 18
      },
      {
        "x": 5,
        "y": 112
      },
      {
        "x": 95,
        "y": 21
      },
      {
        "x": 84,
        "y": 50
      },
      {
        "x": 78,
        "y": 71
      },
      {
        "x": 3,
        "y": 75
      },
      {
        "x": 31,
        "y": 110
      },
      {
        "x": 99,
        "y": 13
      },
      {
        "x": 16,
        "y": 71
      },
      {
        "x": 45,
        "y": 103
      },
      {
        "x": 34,
        "y": 71
      },
      {
        "x": 32,
        "y": 41
      },
      {
        "x": 55,
        "y": 85
      },
      {
        "x": 11,
        "y": 46
      },
      {
        "x": 26,
        "y": 45
      },
      {
        "x": 93,
        "y": 85
      },
      {
        "x": 14,
        "y": 42
      },
      {
        "x": 98,
        "y": 94
      },
      {
        "x": 1,
        "y": 64
      },
      {
        "x": 4,
        "y": 109
      },
      {
        "x": 61,
        "y": 118
      },
      {
        "x": 76,
        "y": 80
      },
      {
        "x": 88,
        "y": 2
      },
      {
        "x": 64,
        "y": 65
      },
      {
        "x": 46,
        "y": 26
      }
    ]
  }
]
const dcircle = {
  "name": "nivo",
  "color": "hsl(205, 70%, 50%)",
  "children": [
    {
      "name": "viz",
      "color": "hsl(86, 70%, 50%)",
      "children": [
        {
          "name": "stack",
          "color": "hsl(85, 70%, 50%)",
          "children": [
            {
              "name": "cchart",
              "color": "hsl(90, 70%, 50%)",
              "loc": 32060
            },
            {
              "name": "xAxis",
              "color": "hsl(245, 70%, 50%)",
              "loc": 132952
            },
            {
              "name": "yAxis",
              "color": "hsl(176, 70%, 50%)",
              "loc": 33044
            },
            {
              "name": "layers",
              "color": "hsl(214, 70%, 50%)",
              "loc": 76373
            }
          ]
        },
        {
          "name": "ppie",
          "color": "hsl(49, 70%, 50%)",
          "children": [
            {
              "name": "chart",
              "color": "hsl(353, 70%, 50%)",
              "children": [
                {
                  "name": "pie",
                  "color": "hsl(156, 70%, 50%)",
                  "children": [
                    {
                      "name": "outline",
                      "color": "hsl(11, 70%, 50%)",
                      "loc": 77128
                    },
                    {
                      "name": "slices",
                      "color": "hsl(170, 70%, 50%)",
                      "loc": 88830
                    },
                    {
                      "name": "bbox",
                      "color": "hsl(340, 70%, 50%)",
                      "loc": 104786
                    }
                  ]
                },
                {
                  "name": "donut",
                  "color": "hsl(348, 70%, 50%)",
                  "loc": 169502
                },
                {
                  "name": "gauge",
                  "color": "hsl(104, 70%, 50%)",
                  "loc": 118353
                }
              ]
            },
            {
              "name": "legends",
              "color": "hsl(223, 70%, 50%)",
              "loc": 125772
            }
          ]
        }
      ]
    },
    {
      "name": "colors",
      "color": "hsl(215, 70%, 50%)",
      "children": [
        {
          "name": "rgb",
          "color": "hsl(49, 70%, 50%)",
          "loc": 163418
        },
        {
          "name": "hsl",
          "color": "hsl(272, 70%, 50%)",
          "loc": 33537
        }
      ]
    },
    {
      "name": "utils",
      "color": "hsl(300, 70%, 50%)",
      "children": [
        {
          "name": "randomize",
          "color": "hsl(139, 70%, 50%)",
          "loc": 173176
        },
        {
          "name": "resetClock",
          "color": "hsl(33, 70%, 50%)",
          "loc": 26389
        },
        {
          "name": "noop",
          "color": "hsl(218, 70%, 50%)",
          "loc": 35165
        },
        {
          "name": "tick",
          "color": "hsl(197, 70%, 50%)",
          "loc": 67121
        },
        {
          "name": "forceGC",
          "color": "hsl(88, 70%, 50%)",
          "loc": 15883
        },
        {
          "name": "stackTrace",
          "color": "hsl(121, 70%, 50%)",
          "loc": 28403
        },
        {
          "name": "dbg",
          "color": "hsl(162, 70%, 50%)",
          "loc": 36991
        }
      ]
    },
    {
      "name": "generators",
      "color": "hsl(37, 70%, 50%)",
      "children": [
        {
          "name": "address",
          "color": "hsl(12, 70%, 50%)",
          "loc": 148835
        },
        {
          "name": "city",
          "color": "hsl(157, 70%, 50%)",
          "loc": 135362
        },
        {
          "name": "animal",
          "color": "hsl(129, 70%, 50%)",
          "loc": 182542
        },
        {
          "name": "movie",
          "color": "hsl(271, 70%, 50%)",
          "loc": 28368
        },
        {
          "name": "user",
          "color": "hsl(150, 70%, 50%)",
          "loc": 73129
        }
      ]
    },
    {
      "name": "set",
      "color": "hsl(139, 70%, 50%)",
      "children": [
        {
          "name": "clone",
          "color": "hsl(296, 70%, 50%)",
          "loc": 144014
        },
        {
          "name": "intersect",
          "color": "hsl(266, 70%, 50%)",
          "loc": 80884
        },
        {
          "name": "merge",
          "color": "hsl(262, 70%, 50%)",
          "loc": 198937
        },
        {
          "name": "reverse",
          "color": "hsl(127, 70%, 50%)",
          "loc": 131116
        },
        {
          "name": "toArray",
          "color": "hsl(304, 70%, 50%)",
          "loc": 67829
        },
        {
          "name": "toObject",
          "color": "hsl(85, 70%, 50%)",
          "loc": 107928
        },
        {
          "name": "fromCSV",
          "color": "hsl(193, 70%, 50%)",
          "loc": 91156
        },
        {
          "name": "slice",
          "color": "hsl(183, 70%, 50%)",
          "loc": 100074
        },
        {
          "name": "append",
          "color": "hsl(102, 70%, 50%)",
          "loc": 28553
        },
        {
          "name": "prepend",
          "color": "hsl(77, 70%, 50%)",
          "loc": 136248
        },
        {
          "name": "shuffle",
          "color": "hsl(158, 70%, 50%)",
          "loc": 136943
        },
        {
          "name": "pick",
          "color": "hsl(102, 70%, 50%)",
          "loc": 29547
        },
        {
          "name": "plouc",
          "color": "hsl(45, 70%, 50%)",
          "loc": 128694
        }
      ]
    },
    {
      "name": "text",
      "color": "hsl(260, 70%, 50%)",
      "children": [
        {
          "name": "trim",
          "color": "hsl(103, 70%, 50%)",
          "loc": 123642
        },
        {
          "name": "slugify",
          "color": "hsl(207, 70%, 50%)",
          "loc": 80794
        },
        {
          "name": "snakeCase",
          "color": "hsl(244, 70%, 50%)",
          "loc": 138085
        },
        {
          "name": "camelCase",
          "color": "hsl(154, 70%, 50%)",
          "loc": 13409
        },
        {
          "name": "repeat",
          "color": "hsl(102, 70%, 50%)",
          "loc": 21927
        },
        {
          "name": "padLeft",
          "color": "hsl(250, 70%, 50%)",
          "loc": 145058
        },
        {
          "name": "padRight",
          "color": "hsl(6, 70%, 50%)",
          "loc": 62143
        },
        {
          "name": "sanitize",
          "color": "hsl(278, 70%, 50%)",
          "loc": 163980
        },
        {
          "name": "ploucify",
          "color": "hsl(199, 70%, 50%)",
          "loc": 84197
        }
      ]
    },
    {
      "name": "misc",
      "color": "hsl(207, 70%, 50%)",
      "children": [
        {
          "name": "greetings",
          "color": "hsl(325, 70%, 50%)",
          "children": [
            {
              "name": "hey",
              "color": "hsl(309, 70%, 50%)",
              "loc": 96570
            },
            {
              "name": "HOWDY",
              "color": "hsl(306, 70%, 50%)",
              "loc": 74325
            },
            {
              "name": "aloha",
              "color": "hsl(154, 70%, 50%)",
              "loc": 159080
            },
            {
              "name": "AHOY",
              "color": "hsl(315, 70%, 50%)",
              "loc": 166942
            }
          ]
        },
        {
          "name": "other",
          "color": "hsl(271, 70%, 50%)",
          "loc": 196538
        },
        {
          "name": "path",
          "color": "hsl(99, 70%, 50%)",
          "children": [
            {
              "name": "pathA",
              "color": "hsl(163, 70%, 50%)",
              "loc": 19235
            },
            {
              "name": "pathB",
              "color": "hsl(238, 70%, 50%)",
              "children": [
                {
                  "name": "pathB1",
                  "color": "hsl(113, 70%, 50%)",
                  "loc": 80685
                },
                {
                  "name": "pathB2",
                  "color": "hsl(328, 70%, 50%)",
                  "loc": 187182
                },
                {
                  "name": "pathB3",
                  "color": "hsl(184, 70%, 50%)",
                  "loc": 32469
                },
                {
                  "name": "pathB4",
                  "color": "hsl(123, 70%, 50%)",
                  "loc": 107220
                }
              ]
            },
            {
              "name": "pathC",
              "color": "hsl(153, 70%, 50%)",
              "children": [
                {
                  "name": "pathC1",
                  "color": "hsl(59, 70%, 50%)",
                  "loc": 47461
                },
                {
                  "name": "pathC2",
                  "color": "hsl(20, 70%, 50%)",
                  "loc": 111273
                },
                {
                  "name": "pathC3",
                  "color": "hsl(146, 70%, 50%)",
                  "loc": 32540
                },
                {
                  "name": "pathC4",
                  "color": "hsl(292, 70%, 50%)",
                  "loc": 144079
                },
                {
                  "name": "pathC5",
                  "color": "hsl(85, 70%, 50%)",
                  "loc": 7406
                },
                {
                  "name": "pathC6",
                  "color": "hsl(248, 70%, 50%)",
                  "loc": 81238
                },
                {
                  "name": "pathC7",
                  "color": "hsl(214, 70%, 50%)",
                  "loc": 127166
                },
                {
                  "name": "pathC8",
                  "color": "hsl(104, 70%, 50%)",
                  "loc": 73271
                },
                {
                  "name": "pathC9",
                  "color": "hsl(335, 70%, 50%)",
                  "loc": 175156
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}


const dcircle1 = {
  "name": "199",
  "color": "hsl(210, 70%, 50%)",
  "children": [
    {
      "name": "18",
      "color": "hsl(156, 70%, 50%)",
      "children": [
        {
          "children": [
            {
              "name": "4",
              "color": "hsl(250, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "39",
              "color": "hsl(96, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "48",
              "color": "hsl(184, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "57",
              "color": "hsl(172, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "62",
              "color": "hsl(144, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "210",
              "color": "hsl(176, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "214",
              "color": "hsl(126, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "215",
              "color": "hsl(200, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45002",
              "color": "hsl(244, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45003",
              "color": "hsl(248, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45005",
              "color": "hsl(240, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45006",
              "color": "hsl(238, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "45008",
              "color": "hsl(236, 70%, 50%)",
              "loc": "4322"
            }
          ]
        },
        {
          "children": []
        },
        {
          "children": [
            {
              "name": "72",
              "color": "hsl(80, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "75",
              "color": "hsl(102, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "100",
              "color": "hsl(118, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "134",
              "color": "hsl(136, 70%, 50%)",
              "loc": "4322"
            }
          ]
        }
      ]
    },
    {
      "name": "19",
      "color": "hsl(210, 70%, 50%)",
      "children": [
        {
          "children": [
            {
              "name": "225",
              "color": "hsl(214, 70%, 50%)",
              "loc": "4322"
            }
          ]
        },
        {
          "children": [
            {
              "name": "130",
              "color": "hsl(208, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "185",
              "color": "hsl(206, 70%, 50%)",
              "loc": "4322"
            }
          ]
        },
        {
          "children": [
            {
              "name": "135",
              "color": "hsl(364, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "152",
              "color": "hsl(354, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "175",
              "color": "hsl(362, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "191",
              "color": "hsl(360, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "212",
              "color": "hsl(302, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "216",
              "color": "hsl(356, 70%, 50%)",
              "loc": "4322"
            }
          ]
        }
      ]
    },
    {
      "name": "50",
      "color": "hsl(150, 70%, 50%)",
      "children": [
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        }
      ]
    },
    {
      "name": "209",
      "color": "hsl(46, 70%, 50%)",
      "children": [
        {
          "children": [
            {
              "name": "9",
              "color": "hsl(220, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "16",
              "color": "hsl(48, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "149",
              "color": "hsl(256, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "180",
              "color": "hsl(34, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "201",
              "color": "hsl(202, 70%, 50%)",
              "loc": "4322"
            },
            {
              "name": "222",
              "color": "hsl(160, 70%, 50%)",
              "loc": "4322"
            }
          ]
        }
      ]
    },
    {
      "name": "219",
      "color": "hsl(338, 70%, 50%)",
      "children": [
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        },
        {
          "children": []
        }
      ]
    }
  ]
}


          const MyResponsiveNetwork = ({ data1 /* see data tab */ }) => (
            <ResponsiveNetwork
          //  height={800}
          //  width={700}
                data={data1}
             //   margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                linkDistance={function(e){return e.distance}}
                centeringStrength={0.2}
                repulsivity={58}
                iterations={1000}
                nodeSize={function(n){return n.size}}
                activeNodeSize={function(n){return 3.5*n.size}}
                nodeColor={function(e){return e.color}}
                nodeBorderWidth={1}
                animate={true}
                nodeBorderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.8
                        ]
                    ]
                }}
                linkThickness={function(n){return 2+2*n.target.data.height}}
                linkBlendMode="multiply"
                motionConfig="wobbly"
                label={data1=> data1.nodes.id}
            />
        )        

        // head count display calculation start
        


        // make sure parent container have a defined height when using
        // responsive component, otherwise height will be 0 and
        // no chart will be rendered.
        // website examples showcase many properties,
        // you'll often use just a few of them.
        const MyResponsiveAreaBump = ({ data /* see data tab */ }) => (
            <ResponsiveAreaBump
             height={290}
             width={495}
                data={data}
                margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
                spacing={8}
                colors={{ scheme: 'nivo' }}
                blendMode="multiply"
                defs={[
                    {
                        id: 'dots',
                        type: 'patternDots',
                        background: 'inherit',
                        color: '#38bcb2',
                        size: 4,
                        padding: 1,
                        stagger: true
                    },
                    {
                        id: 'lines',
                        type: 'patternLines',
                        background: 'inherit',
                        color: '#eed312',
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10
                    }
                ]}
                fill={[
                    {
                        match: {
                            id: 'CoffeeScript'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'TypeScript'
                        },
                        id: 'lines'
                    }
                ]}
                startLabel="id"
                endLabel="id"
                axisTop={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Year',
                    legendPosition: 'middle',
                    legendOffset: -36
                }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Year',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
            />
        )        

        const MyResponsiveBump = ({ data /* see data tab */ }) => (
            <ResponsiveBump
            height={290}
            width={490}
                data={data}
                colors={{ scheme: 'nivo' }}
                lineWidth={3}
                activeLineWidth={3}
                inactiveLineWidth={1}
                inactiveOpacity={0.15}
                startLabelPadding={30}
                inactivePointSize={0}
                startLabel={'true'}
                pointColor={{ theme: 'background' }}
                pointBorderWidth={2}
                activePointBorderWidth={3}
                pointBorderColor={{ from: 'serie.color' }}
                axisTop={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 27,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: -36
                }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
                axisLeft={null}
                margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
                axisRight={null}
            />
        )
        
   
        const MyResponsiveBar = ({ data /* see data tab */ }) => {
          return (
            <ResponsiveBar 
              data={data}
              keys={["degress"]}
              indexBy="day"
              margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
              padding={0.4}
              valueScale={{ type: "linear" }}
              animate={true}
              enableLabel={false}
              axisTop={null}
              axisRight={null}
              axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "degrees",
                legendPosition: "middle",
                legendOffset: -40
              }}
            />
          );
      };
        
        const MyResponsivePie = ({ data /* see data tab */ }) => (
            <ResponsivePie
            height={290}
            width={390}
                data={data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.6}
                padAngle={1.8}
                cornerRadius={8}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.2
                        ]
                    ]
                }}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={3}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.2
                        ]
                    ]
                }}
                defs={[
                    {
                        id: 'dots',
                        type: 'patternDots',
                        background: 'inherit',
                        color: 'rgba(255, 255, 255, 0.3)',
                        size: 4,
                        padding: 1,
                        stagger: true
                    },
                    {
                        id: 'lines',
                        type: 'patternLines',
                        background: 'inherit',
                        color: 'rgba(255, 255, 255, 0.3)',
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10
                    }
                ]}
                fill={[
                    {
                        match: {
                            id: 'ruby'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'c'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'go'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'python'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'scala'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'lisp'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'elixir'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'javascript'
                        },
                        id: 'lines'
                    }
                ]}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: 56,
                        itemsSpacing: 0,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        )

        const MyResponsiveChord = ({ data /* see data tab */ }) => (
            <ResponsiveChord
            height={290}
            width={390}
                data={data}

                keys={[ 'John', 'Raoul', 'Jane', 'Marcel', 'Ibrahim' ]}
                margin={{ top: 60, right: 60, bottom: 90, left: 70 }}
                valueFormat=".2f"
                padAngle={0.02}
                innerRadiusRatio={0.96}
                innerRadiusOffset={0.02}
                inactiveArcOpacity={0.25}
                arcBorderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.6
                        ]
                    ]
                }}
                activeRibbonOpacity={0.75}
                inactiveRibbonOpacity={0.25}
                ribbonBorderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.6
                        ]
                    ]
                }}
                labelRotation={-90}
                labelTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1
                        ]
                    ]
                }}
                colors={{ scheme: 'category10' }}
                motionConfig="stiff"
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: 70,
                        itemWidth: 80,
                        itemHeight: 14,
                        itemsSpacing: 0,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        symbolSize: 12,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        )

        const MyResponsiveChoropleth = ({ data /* see data tab */ }) => (
            <ResponsiveChoropleth
                data={data}
              //  features={countries.features}
                height={290}
                width={390}
                margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                colors="nivo"
                domain={[ 0, 1000000 ]}
                unknownColor="#666666"
                label="properties.name"
                valueFormat=".2s"
                projectionTranslation={[ 0.5, 0.5 ]}
                projectionRotation={[ 0, 0, 0 ]}
                enableGraticule={true}
                graticuleLineColor="#dddddd"
                borderWidth={0.5}
                borderColor="#152538"
                defs={[
                    {
                        id: 'dots',
                        type: 'patternDots',
                        background: 'inherit',
                        color: '#38bcb2',
                        size: 4,
                        padding: 1,
                        stagger: true
                    },
                    {
                        id: 'lines',
                        type: 'patternLines',
                        background: 'inherit',
                        color: '#eed312',
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10
                    },
                    {
                        id: 'gradient',
                        type: 'linearGradient',
                        colors: [
                            {
                                offset: 0,
                                color: '#000'
                            },
                            {
                                offset: 100,
                                color: 'inherit'
                            }
                        ]
                    }
                ]}
                fill={[
                    {
                        match: {
                            id: 'CAN'
                        },
                        id: 'dots'
                    },
                    {
                        match: {
                            id: 'CHN'
                        },
                        id: 'lines'
                    },
                    {
                        match: {
                            id: 'ATA'
                        },
                        id: 'gradient'
                    }
                ]}
                legends={[
                    {
                        anchor: 'bottom-left',
                        direction: 'column',
                        justify: true,
                        translateX: 20,
                        translateY: -100,
                        itemsSpacing: 0,
                        itemWidth: 94,
                        itemHeight: 18,
                        itemDirection: 'left-to-right',
                        itemTextColor: '#444444',
                        itemOpacity: 0.85,
                        symbolSize: 18,
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000000',
                                    itemOpacity: 1
                                }
                            }
                        ]
                    }
                ]}
            />
        )
        const MyResponsiveFunnel = ({ data /* see data tab */ }) => (
          <ResponsiveFunnel
          height={290}
          width={390}
              data={data}
              margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
              valueFormat=">-.4s"
              colors={{ scheme: 'spectral' }}
              borderWidth={20}
              labelColor={{
                  from: 'color',
                  modifiers: [
                      [
                          'darker',
                          3
                      ]
                  ]
              }}
              beforeSeparatorLength={100}
              beforeSeparatorOffset={20}
              afterSeparatorLength={100}
              afterSeparatorOffset={20}
              currentPartSizeExtension={10}
              currentBorderWidth={40}
              motionConfig="wobbly"
          />
      )
        const MyResponsiveGeoMap = ({ data /* see data tab */ })  => (
            <ResponsiveChoropleth
            data={data}
               features={[]}
                margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                projectionTranslation={[ 0.5, 0.5 ]}
                projectionRotation={[ 0, 0, 0 ]}
                fillColor="#eeeeee"
                borderWidth={0.5}
                borderColor="#333333"
                enableGraticule={true}
                graticuleLineColor="#666666"
            />
        )
        const MyResponsiveHeatMap = ({ data /* see data tab */ }) => (
          <ResponsiveHeatMap
          height={290}
          width={490}
              data={data}
              margin={{ top: 60, right: 90, bottom: 60, left: 90 }}
              valueFormat=">-.2s"
              axisTop={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -90,
                  legend: '',
                  legendOffset: 46
              }}
              axisRight={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: 'country',
                  legendPosition: 'middle',
                  legendOffset: 70
              }}
              axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: 'country',
                  legendPosition: 'middle',
                  legendOffset: -72
              }}
              colors={{
                  type: 'diverging',
                  scheme: 'red_yellow_blue',
                  divergeAt: 0.5,
                  minValue: -100000,
                  maxValue: 100000
              }}
              emptyColor="#555555"
              legends={[
                  {
                      anchor: 'bottom',
                      translateX: 0,
                      translateY: 30,
                      length: 400,
                      thickness: 8,
                      direction: 'row',
                      tickPosition: 'after',
                      tickSize: 3,
                      tickSpacing: 4,
                      tickOverlap: false,
                      tickFormat: '>-.2s',
                      title: 'Value →',
                      titleAlign: 'start',
                      titleOffset: 4
                  }
              ]}
          />
      )

      const MyResponsiveLine = ({ data /* see data tab */ }) => (
        <ResponsiveLine
            data={data}
            height={290}
            width={790}
            animate
            curve="monotoneX"
            enableArea
            enableSlices="x"
            fill={[
              {
                id: 'gradientA',
                match: '*'
              }
            ]}
            margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{
                type: 'linear',
                min: 'auto',
                max: 'auto',
                stacked: true,
                reverse: false
            }}
            yFormat=" >-.2f"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'transportation',
                legendOffset: 36,
                legendPosition: 'middle'
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'count',
                legendOffset: -40,
                legendPosition: 'middle'
            }}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh={true}
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    )

    const MyResponsiveMarimekko = ({ data /* see data tab */ }) => (
      <ResponsiveMarimekko
          data={data}
          height={290}
          width={450}
          id="statement"
          value="participation"
          dimensions={[
              {
                  id: 'disagree strongly',
                  value: 'stronglyDisagree'
              },
              {
                  id: 'disagree',
                  value: 'disagree'
              },
              {
                  id: 'agree',
                  value: 'agree'
              },
              {
                  id: 'agree strongly',
                  value: 'stronglyAgree'
              }
          ]}
          innerPadding={9}
          axisTop={null}
          axisRight={{
              orient: 'right',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: '',
              legendOffset: 0
          }}
          axisBottom={{
              orient: 'bottom',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'participation',
              legendOffset: 36,
              legendPosition: 'middle'
          }}
          axisLeft={{
              orient: 'left',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'opinions',
              legendOffset: -40,
              legendPosition: 'middle'
          }}
          margin={{ top: 40, right: 80, bottom: 100, left: 80 }}
          colors={{ scheme: 'spectral' }}
          borderWidth={1}
          borderColor={{
              from: 'color',
              modifiers: [
                  [
                      'darker',
                      0.2
                  ]
              ]
          }}
          defs={[
              {
                  id: 'lines',
                  type: 'patternLines',
                  background: 'rgba(0, 0, 0, 0)',
                  color: 'inherit',
                  rotation: -45,
                  lineWidth: 4,
                  spacing: 8
              }
          ]}
          fill={[
              {
                  match: {
                      id: 'agree strongly'
                  },
                  id: 'lines'
              },
              {
                  match: {
                      id: 'disagree strongly'
                  },
                  id: 'lines'
              }
          ]}
          legends={[
              {
                  anchor: 'bottom',
                  direction: 'row',
                  justify: false,
                  translateX: 0,
                  translateY: 80,
                  itemsSpacing: 0,
                  itemWidth: 140,
                  itemHeight: 18,
                  itemTextColor: '#999',
                  itemDirection: 'right-to-left',
                  itemOpacity: 1,
                  symbolSize: 18,
                  symbolShape: 'square',
                  effects: [
                      {
                          on: 'hover',
                          style: {
                              itemTextColor: '#000'
                          }
                      }
                  ]
              }
          ]}
      />
  )

  const MyResponsiveRadar = ({ data /* see data tab */ }) => (
    <ResponsiveRadar
    height={290}
    width={400}
        data={data}
        keys={[ 'chardonay', 'carmenere', 'syrah' ]}
        indexBy="taste"
        valueFormat=">-.2f"
        margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
        borderColor={{ from: 'color' }}
        gridLabelOffset={36}
        dotSize={10}
        dotColor={{ theme: 'background' }}
        dotBorderWidth={2}
        colors={{ scheme: 'nivo' }}
        blendMode="multiply"
        motionConfig="wobbly"
        legends={[
            {
                anchor: 'top-left',
                direction: 'column',
                translateX: -50,
                translateY: -40,
                itemWidth: 80,
                itemHeight: 20,
                itemTextColor: '#999',
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ]
            }
        ]}
    />
)

const MyResponsiveSwarmPlot = ({ data /* see data tab */ }) => (
  <ResponsiveSwarmPlot
      data={data}
      groups={[ 'group A', 'group B', 'group C' ]}
      identity="id"
      value="price"
      valueFormat="$.2f"
      valueScale={{ type: 'linear', min: 0, max: 500, reverse: false }}
      size={{
          key: 'volume',
          values: [
              4,
              20
          ],
          sizes: [
              6,
              20
          ]
      }}
      forceStrength={4}
      simulationIterations={100}
      borderColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  0.6
              ],
              [
                  'opacity',
                  0.5
              ]
          ]
      }}
      margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
      axisTop={{
          orient: 'top',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'group if vertical, price if horizontal',
          legendPosition: 'middle',
          legendOffset: -46
      }}
      axisRight={{
          orient: 'right',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'price if vertical, group if horizontal',
          legendPosition: 'middle',
          legendOffset: 76
      }}
      axisBottom={{
          orient: 'bottom',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'group if vertical, price if horizontal',
          legendPosition: 'middle',
          legendOffset: 46
      }}
      axisLeft={{
          orient: 'left',
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'price if vertical, group if horizontal',
          legendPosition: 'middle',
          legendOffset: -76
      }}
  />
)

const MyResponsiveScatterPlot = ({ data /* see data tab */ }) => (
  <ResponsiveScatterPlot
      data={data}
      margin={{ top: 60, right: 140, bottom: 80, left: 90 }}
      xScale={{ type: 'linear', min: 0, max: 'auto' }}
      xFormat=">-.2f"
      yScale={{ type: 'linear', min: 0, max: 'auto' }}
      yFormat=">-.2f"
      blendMode="multiply"
      axisTop={null}
      axisRight={null}
      axisBottom={{
          orient: 'bottom',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'weight',
          legendPosition: 'middle',
          legendOffset: 46
      }}
      axisLeft={{
          orient: 'left',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'size',
          legendPosition: 'middle',
          legendOffset: -60
      }}
      legends={[
          {
              anchor: 'bottom-right',
              direction: 'column',
              justify: false,
              translateX: 130,
              translateY: 0,
              itemWidth: 100,
              itemHeight: 12,
              itemsSpacing: 5,
              itemDirection: 'left-to-right',
              symbolSize: 12,
              symbolShape: 'circle',
              effects: [
                  {
                      on: 'hover',
                      style: {
                          itemOpacity: 1
                      }
                  }
              ]
          }
      ]}
  />
)
const MyResponsiveCirclePacking = ({ data /* see data tab */ }) => (
  <ResponsiveCirclePacking
      data={data}
      margin={{ top: 50, right: 20, bottom: 90, left: 20 }}
      id="name"
      value="loc"
      colors={{ scheme: 'red_purple' }}
      childColor={{
          from: 'color',
          modifiers: [
              [
                  'brighter',
                  0.4
              ]
          ]
      }}
      padding={4}
      enableLabels={true}
      labelsFilter={n=>2===n.node.depth}
      labelsSkipRadius={10}
      labelTextColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  2
              ]
          ]
      }}
      borderWidth={1}
      borderColor={{
          from: 'color',
          modifiers: [
              [
                  'darker',
                  0.5
              ]
          ]
      }}
      defs={[
          {
              id: 'lines',
              type: 'patternLines',
              background: 'none',
              color: 'inherit',
              rotation: -45,
              lineWidth: 5,
              spacing: 8
          }
      ]}
      fill={[
          {
              match: {
                  depth: 1
              },
              id: 'lines'
          }
      ]}
  />
)
const  pbdata= {
  datasets: [{
      data: [10, 20, 30],
  }],
  labels: [
      'Red',
      'Yellow',
      'Blue'
  ]
};

const documentStyle = getComputedStyle(document.documentElement);
const textColor = documentStyle.getPropertyValue('--text-color');
const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
const surfaceBorder = documentStyle.getPropertyValue('--surface-border');


const pbsdata = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
      {
          type: 'bar',
          label: 'Dataset 1',
          backgroundColor: '#DAF7A6',
          data: [50, 25, 12, 48, 90, 76, 42]
      },
      {
          type: 'bar',
          label: 'Dataset 2',
          backgroundColor: '#FFC300',
          data: [21, 84, 24, 75, 37, 65, 34]
      },
      {
          type: 'bar',
          label: 'Dataset 3',
          backgroundColor: '#FF5733',
          data: [41, 52, 24, 74, 23, 21, 32]
      }
  ]
};
const pbsoptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
      tooltips: {
          mode: 'index',
          intersect: false
      },
      legend: {
          labels: {
              color: '#581845'
          }
      }
  },
  scales: {
      x: {
          stacked: true,
          ticks: {
              color: '#900C3F'
          },
          grid: {
              color: '#C70039'

          }
      },
      y: {
          stacked: true,
          ticks: {
              color: '#99bbc4'
          },
          grid: {
              color: '#99a5c4'
          }
      }
  }
};

const ppdata = {
  datasets: [
      {
          data: [11, 16, 7, 3, 14],
          backgroundColor: [
            '#99bbc4',
              '#DAF7A6',
              '#FFC300',
              '#FF5733',
              '#C70039'
          ],
          label: 'My dataset'
      }
  ],
  labels: ['Red', 'Green', 'Yellow', 'Grey', 'Blue']
};

const ppoptions = {
  plugins: {
      legend: {
          labels: {
              color: '#ADC499',
              position: 'bottom',
              display: false
          }
          
      }
  },
  scales: {
      r: {
          grid: {
              color: '#999FC4'
          }
      }
  }
};

function extLegend() 
{
    this.cfg.legend= {
        show: true,
        location: 's',
        placement: 'outsideGrid',
        position: 'left'
    };
}
let openclosepermit =[];
  //let totalpermit =(requestListData[7] && requestListData[7].length > 0 ) ? requestListData[7] : [];
        let totalpermitd= requestListData[7] && requestListData[7].find(el => el.labels == 'TOTAL PERMITS').data || 0; 
            let totalclosedpermitd=  requestListData[8] && requestListData[8].find(el => el.labels == 'CLOSED PERMITS').data || 0; 
        let totalopenpermitd = (totalpermitd - totalclosedpermitd  >= 0) ? (totalpermitd - totalclosedpermitd) : 0; //calculation to avoid negative numbers
openclosepermit.push(totalpermitd, totalclosedpermitd);
const openclosepermitdoughdata = {
  labels: ['Open', 'Closed'],
  datasets: [
      {
          data: openclosepermit,
          backgroundColor: [
            '#ADC499', 
            '#999FC4', 
            '#C70039'
          ],
          hoverBackgroundColor: [
            '#FF5733', 
            '#FFC300', 
            '#FF5733'
          ]
      }
  ]
};

let highlowriskpermit =[];
  //let totalpermit =(requestListData[7] && requestListData[7].length > 0 ) ? requestListData[7] : [];
       // let totalpermitd2= requestListData[7] && requestListData[7].find(el => el.labels == 'TOTAL PERMITS').data || 0; 
            let totalhighriskpermitd=  requestListData[5] && requestListData[5].find(el => el.labels == 'HIGH RISK WORKPERMIT').data || 0; 
        let totallowriskpermitd = (totalpermitd - totalhighriskpermitd  >= 0) ? (totalpermitd - totalhighriskpermitd) : 0; //calculation to avoid negative numbers
        highlowriskpermit.push(totalhighriskpermitd, totallowriskpermitd);
const riskpermitdoughdata = {
  labels: ['HIGH RISK WORKPERMIT', 'LOW RISK WORKPERMIT'],
  datasets: [
      {
          data: highlowriskpermit,
          backgroundColor: [
            '#FF5733', 
            '#FFC300', 
            '#FF5733'
          ],
          hoverBackgroundColor: [
            '#ADC499', 
            '#999FC4', 
            '#C70039'
          ]
      }
  ]
};

const pdoughoptions = {
  cutout: '60%'
};

const pbvdata = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
      {
          label: 'My First dataset',
          backgroundColor: '#ADC499',
          borderColor: '#FF5733',
          data: [65, 59, 80, 81, 56, 55, 40]
      },
      {
          label: 'My Second dataset',
          backgroundColor: '#999FC4',
          borderColor: '#FFC300',
          data: [28, 48, 40, 19, 86, 27, 90]
      }
  ]
};
const pbvoptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {
      legend: {
          labels: {
              fontColor: '#FF5733'
          }
      }
  },
  scales: {
      x: {
          ticks: {
              color: '#C70039',
              font: {
                  weight: 500
              }
          },
          grid: {
              display: false,
              drawBorder: false
          }
      },
      y: {
          ticks: {
              color: '#C70039'
          },
          grid: {
              color: '#C70039',
              drawBorder: false
          }
      }
  }
};


const pldata = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
      {
          label: 'First Dataset',
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4
      },
      // {
      //     label: 'Second Dataset',
      //     data: [28, 48, 40, 19, 86, 27, 90],
      //     fill: false,
      //     borderColor: documentStyle.getPropertyValue('--pink-500'),
      //     tension: 0.4
      // }
  ]
};
const ploptions = {
  maintainAspectRatio: false,
  aspectRatio: 0.6,
  plugins: {
      legend: {
          labels: {
              color: '#C70039'
          }
      }
  },
  scales: {
      x: {
          ticks: {
              color:'#FF5733'
          },
          grid: {
              color: '#999FC4'
          }
      },
      y: {
          ticks: {
              color: '#FF5733'
          },
          grid: {
              color: '#999FC4'
          }
      }
  }
};
let isolationd =[];
let isolationlocation =[];

     isolationd= requestListData[0] && requestListData[0].reduce((a, el) => {
             a.push(el.data);
             return a;
         }, []) || []//getting the number of balance days of the allocated leave days from props

     isolationlocation= requestListData[0] && requestListData[0].reduce((a, el) => {
          a.push(el.labels);
          return a;
      }, []) || []//getting the number of balance days of the allocated leave days from props

const ppiedata = {
  labels: isolationlocation,
  datasets: [
      {
          data: isolationd,
          backgroundColor: [
              '#DDB7DF ', 
              '#6968AF', 
              '#834011 ',
              '#ffdce2',
              '#ff8100'
          ],
          hoverBackgroundColor: [
              '#E93B33 ', 
              '#ECC968', 
              '#070501',
              '#00ced1',
              '#db8875'
          ]
      }
  ]
}
const ppieoptions = {
  plugins: {
      legend: {
          labels: {
              usePointStyle: true
          }
      }
  }
};

       //headcount chart 
       let headCountChartData = [];
       let LeaveheadCountChartData = [];        
       let totalNoOfPplInCompany =0;// requestListData[7] && requestListData[7].find(el => el.status == 'ALL').headcount || 0;
       let numberOfPplInPremise = 0;//requestListData[7] && requestListData[7].find(el => el.status == 'IN').headcount || 0; 
       let numberOfPplNotInCompany = 0;//(totalNoOfPplInCompany - numberOfPplInPremise  >= 0) ? (totalNoOfPplInCompany - numberOfPplInPremise) : 0; //calculation to avoid negative numbers

       let totalNoOfPplInAnnualLeave =0;// requestListData[7] && requestListData[7].find(el => el.status == 'ALL').headcount || 0;
       let numberOfPplInSickLeave =0;// requestListData[7] && requestListData[7].find(el => el.status == 'IN').headcount || 0;         
       
       headCountChartData.push(numberOfPplInPremise, numberOfPplNotInCompany);
       const headCountChart = {
           labels: ['On Premise', 'Off Premise'],
           datasets: [
               {
                   data: headCountChartData,
                   backgroundColor: [
                       "#0b9e79",
                       "#e3483d"
                   ],
                   hoverBackgroundColor: [
                       "#0b9e79",
                       "#e3483d"
                   ]
               }]
       }

       LeaveheadCountChartData.push(totalNoOfPplInAnnualLeave, numberOfPplInSickLeave);

        //leave days chart 
        let permitdata =(requestListData[1] && requestListData[1].length > 0 ) ? requestListData[1] : [];
        let hotworkpermitd= (permitdata && permitdata.length > 0  && permitdata.filter(el =>el.permittype == "Permit").map((e) => {return e.data}));

        // let hotworkpermitd = hotworkpermit && hotworkpermit.reduce((a, el) => {
        //     a.push(el.data);
        //     return a;
        // }, []) || []//getting the number of allocated days from props

        let livepermitd= (permitdata && permitdata.length > 0  && permitdata.filter(el =>el.permittype == "Permit Live").map((e) => {return e.data}));

        let accesspermitd= (permitdata && permitdata.length > 0  && permitdata.filter(el =>el.permittype == "Permit Access").map((e) => {return e.data}));
        let roshpermitd= (permitdata && permitdata.length > 0  && permitdata.filter(el =>el.permittype == "Permit Test").map((e) => {return e.data}));
        
        // let livekpermit= (permitdata && permitdata.length > 0  && permitdata.find(el =>el.permittype == "Permit Live")) ? permitdata.find(el =>el.permittype == "Permit Live") : {count: 0};

        // let livepermitd = livekpermit && livekpermit.reduce((a, el) => {
        //     a.push(el.data);
        //     return a;
        // }, []) || []//getting the number of allocated days from props

        let userstatus =           requestListData[1] && requestListData[1].reduce((a, el) => {
             a.push(el.labels);
             return a;
         }, []) || [] //getting all user status type from props */

         const uniqueuserstatus = userstatus.reduce( (all,item) => {
            if(all.indexOf(item) === -1) {
              all.push(item)
            }
            return all
          },[])

        let balanceDaysValues = 0;
        // requestListData[3] && requestListData[3].reduce((a, el) => {
        //     a.push(el.balancE_DAYS);
        //     return a;
        // }, []) || []//getting the number of balance days of the allocated leave days from props

        const barData = {
            labels: uniqueuserstatus,
            datasets: [
                {
                    label: 'Hot Work Permit',
                    backgroundColor: '#fcbaba',
                    data: hotworkpermitd
                },
                {
                    label: 'Permit Live',
                    backgroundColor: '#ffa700',
                    data: livepermitd
                },
                {
                    label: 'Access Permit',
                    backgroundColor: '#b4b387',
                    data: accesspermitd
                },
                {
                    label: 'Rosh Permit',
                    backgroundColor: '#AB89BC',
                    data: roshpermitd
                }
            ]
        }

  //Safety Requests Chart
  let safetyStatisticData =0;// requestListData[9] && requestListData[9] || [];
  let safetyStatusList = 0;
//    requestListData[9] && requestListData[9].reduce((a, el) => {
//       a.push(el.status);
//       return a;
//   }, []) || [] //getting the different of statuses from props

  let safetyReqCount =  0;
//   requestListData[9] && requestListData[9].reduce((a, el) => {
//       a.push(el.count);
//       return a;
//   }, []) || [] //getting the count of corresponding statuses

  let safetyChartData = {
      labels: safetyStatusList,
      datasets: [
          {
              data: safetyReqCount,
              backgroundColor: [
                  "#42A5F5",
                  "#66BB6A",
                  "#FFA726",
                  "#0b9e79",
                  "#e3483d",
                  '#AB47BC'
              ],
              hoverBackgroundColor: [
                  "#64B5F6",
                  "#81C784",
                  "#FFB74D",
                  "#0b9e79",
                  "#e3483d",
                  '#AB47BC'
              ]
          }
      ]
  };


        let headCountData =(requestListData[3] && requestListData[3].length > 0 ) ? requestListData[3] : [];
        let cityOfficeHc= (headCountData && headCountData.length > 0  && headCountData.find(el =>el.labels == "ELE-HVAC")) ? headCountData.find(el =>el.labels == "ELE-HVAC") : {count: 0};
        let ccrHc = (headCountData && headCountData.length > 0  &&  headCountData.find(el => el.labels == "ELE-WTR")) ? headCountData.find(el => el.labels == "ELE-WTR") : {count: 0};
        let siteHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.labels == "ELE-PWR")) ? headCountData.find(el =>el.labels == "ELE-PWR") : {count: 0};
        let mainGateHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.labels == "INST-WTR")) ? headCountData.find(el => el.labels == "INST-WTR") : {count: 0};
        let seaWaterHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.labels == "MECH-WTR")) ? headCountData.find(el =>  el.labels == "MECH-WTR") : {count: 0};
        let missingHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.labels == "INST-PWR")) ? headCountData.find(el => el.labels == "INST-PWR") : {count: 0};
        let Mechpwr = (headCountData && headCountData.length > 0  && headCountData.find(el => el.labels == "MECH-PWR")) ? headCountData.find(el => el.labels == "MECH-PWR") : {count: 0};
  
        let wpStatus =(requestListData[2] && requestListData[2].length > 0 ) ? requestListData[2] : [];
        let created= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Created")) ? wpStatus.find(el =>el.labels == "Created") : {count: 0};
        let prepared= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Prepared")) ? wpStatus.find(el =>el.labels == "Prepared") : {count: 0};
        let Accepted= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Accepted")) ? wpStatus.find(el =>el.labels == "Accepted") : {count: 0};
        let Issued= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Issued")) ? wpStatus.find(el =>el.labels == "Issued") : {count: 0};
        let ReIssue= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Re-Issue")) ? wpStatus.find(el =>el.labels == "Re-Issue") : {count: 0};
        let Surrender= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Surrender")) ? wpStatus.find(el =>el.labels == "Surrender") : {count: 0};
        let Cancellation= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Cancellation")) ? wpStatus.find(el =>el.labels == "Cancellation") : {count: 0};
        let cleared= (wpStatus && wpStatus.length > 0  && wpStatus.find(el =>el.labels == "Cleared")) ? wpStatus.find(el =>el.labels == "Cleared") : {count: 0};
        



        
        // head count display calculation end
let porganizationData = {};
        if(this.props.positionhierarchyData && this.props.positionhierarchyData.length > 0 ){
          porganizationData = this.props.positionhierarchyData
       //  let organizationData = [...new Set(organizationData.map(({ name,color,loc,children }) => ({name,color,loc,children})))];
        porganizationData = {...porganizationData.map(({ name, color, children }) => ({name,color,
            children: children.map(({ name,color,children }) => ({name,color,children: children.map(({name,color, children }) => ({name,color,children:children.map(({ name,color,loc }) => ({name,color,loc })) })) })),
          }))};

       //   porganizationData = {...porganizationData.map(({ name,color,children }) => ({name,color,children}))};
       porganizationData = porganizationData["0"];  
       this.setState({ organizationData:porganizationData});
          
         }

         const organizationData = porganizationData;
        return(

            

          
            <div className="p-grid">
                {/* { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
            <Toast ref={(el) => this.growl = el} /> */}

                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                {/* {(this.getVideoAccess !== undefined && this.getVideoAccess.viewAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title">
                            <h1>Feature Videos</h1>
                            {(this.props.companyData && this.props.companyData.company !== undefined) &&
                                <FeatureVideo companyDetails={this.props.companyData.company} />
                            }
                        </div>
                    </div>
                } */}


                <div className="p-col-12">


    
                  
                    <div className="card" style={{position:'relative'}}>
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}}                               >

                            <div className="mt1 p-col-12">
                                <h1 style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "#ccccff"}}>Operation & Maintenance Analytics </h1>
                            </div>
                        
                            <div className="mt1 p-col-12 ">
                            <div className="p-grid p-justify-start">
                            {/* <div className="p-col-12">
                                    <MultiSelect className="p-col-12" name="SelectedOrg" optionLabel="label" placeholder="Select Business Unit" options={this.state.Department} value={this.state.SelectedOrg} onChange={(e) => this.setState({ SelectedOrg: e.value })}  />
                                </div> */}
                                    {/* <Calendar className="p-col-3" id="monthpicker" value={null} onChange={(e) => this.setState({ date10: e.value })} view="month" dateFormat="mm/yy" yearNavigator yearRange="2000:2030" placeholder="Month"/> */}
                                    <Calendar     className="p-col-3" id="fromdate" value={null} onChange={(e) => this.setState({ dateFrom: e.value })} monthNavigator yearNavigator yearRange="2000:2030" placeholder="From Date"/>
                    
                                    <Calendar     className="p-col-3" id="Todate" value={null} onChange={(e) => this.setState({ dateTo: e.value })} monthNavigator yearNavigator yearRange="2000:2030" placeholder="To Date"/>
                    
                                

                            </div>
                            </div> 
                     </div>
                       
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Open WorkPermit By Work Center</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-even">

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center', }} 
                                        header={<div style={{backgroundColor:'#fcbaba', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>ELE-HVAC</h3></div>}
                                        // footer = {this.headCountFooter('City Office Head Count')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{cityOfficeHc.count}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#7de5f6', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>ELE-WTR</h3></div>}
                                        // footer = {this.headCountFooter('CCR HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{ccrHc.count}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{ textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6',minHeight: '65px'}}><h3>ELE-PWR </h3></div>}
                                        // footer = {this.headCountFooter('Site HeadCount')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', color:'#20d077', padding:'1px' , fontSize: '55px'}}>{siteHc.count}</span>
                                    </Card>
                                    </div> 

                                    {(ccrHc.count > 0 || mainGateHc.count > 0 ||  seaWaterHc.count > 0) && 
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                        <Card 
                                            style={{textAlign: 'center',}} 
                                            header={<div style={{backgroundColor:'#736372', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>INST-WTR</h3></div>}
                                            // footer = {this.headCountFooter('Missing Head Count - Site')}
                                            >
                                            <span style={{color: '#CC3333', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{missingHc.count}</span>
                                        </Card>
                                    </div> 
                                    }

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#ffa700', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>MECH-WTR</h3></div>}
                                        // footer = {this.headCountFooter('Main Gate HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{mainGateHc.count}</span>
                                    </Card>
                                    </div>                         

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#7faf6a', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>INST-PWR</h3></div>}
                                        // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{seaWaterHc.count}</span>
                                    </Card>
                                    </div> 

                                  {/*   <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>MECH-PWR</h3></div>}
                                        // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{Mechpwr.count}</span>
                                    </Card>
                                    </div>  */}
                                </div>
                            </div>
                        </div>  

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Permit Type and Status</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around">

                                <div className="card card-w-title">
                            <h1>Permit Type Status</h1>
                            <Chart type="bar" data={barData} style={{  height: 350,width:800,margin: "0", padding: "0" } } />
                            
                        </div>
                                </div>
                            </div>
                        </div>


                   
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>WorkPermit By Status</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-even">

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center', }} 
                                        header={<div style={{backgroundColor:'#8b80fd', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Created</h3></div>}
                                        // footer = {this.headCountFooter('City Office Head Count')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{created.data}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#ffc61a', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Prepared</h3></div>}
                                        // footer = {this.headCountFooter('CCR HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{prepared.data}</span>
                                    </Card>
                                    </div> 

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{ textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#bada55', textAlign: 'center', padding:'1px', color:'#F6F6F6',minHeight: '65px'}}><h3>Accepted </h3></div>}
                                        // footer = {this.headCountFooter('Site HeadCount')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', color:'#20d077', padding:'1px' , fontSize: '55px'}}>{Accepted.data}</span>
                                    </Card>
                                    </div> 

                                    {(ccrHc.count > 0 || mainGateHc.count > 0 ||  seaWaterHc.count > 0) && 
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                        <Card 
                                            style={{textAlign: 'center',}} 
                                            header={<div style={{backgroundColor:'#bbab39', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Issued</h3></div>}
                                            // footer = {this.headCountFooter('Missing Head Count - Site')}
                                            >
                                            <span style={{color: '#CC3333', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{Issued.data}</span>
                                        </Card>
                                    </div> 
                                    }

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#ff8100', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Surrender</h3></div>}
                                        // footer = {this.headCountFooter('Main Gate HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{Surrender.data}</span>
                                    </Card>
                                    </div>                         

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#b4b387', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Reissued</h3></div>}
                                        // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{ReIssue.data}</span>
                                    </Card>
                                    </div> 

{/*                                     <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                                    <Card 
                                        style={{textAlign: 'center',}} 
                                        header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '65px'}}><h3>Cancelled</h3></div>}
                                        // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                        >
                                        <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{Cancellation.data}</span>
                                    </Card>
                                    </div>  */}
                                </div>
                            </div>
                        </div>  

                        { (getHeadCountChrtAccess !== undefined && getHeadCountChrtAccess !== false) &&
                    <div className="p-col-12 p-lg1-12 animated fadeIn " >
                    <div className="card " style={{textAlign: 'center'}}>
                    <h1>Head Count</h1>
                        <div className="p-grid p-justify-even">

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center', }} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>City Office</h3></div>}
                            footer = {this.headCountFooter('City Office Head Count')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{cityOfficeHc.count}</span>
                        </Card>
                        </div> 

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>CCR-Assembly Point</h3></div>}
                            footer = {this.headCountFooter('CCR HC - Assembly Point')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{ccrHc.count}</span>
                        </Card>
                        </div> 

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{ textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6',minHeight: '80px'}}><h3>Site </h3></div>}
                            footer = {this.headCountFooter('Site HeadCount')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', color:'#20d077', padding:'1px' , fontSize: '55px'}}>{siteHc.count}</span>
                        </Card>
                        </div> 

                        {(ccrHc.count > 0 || mainGateHc.count > 0 ||  seaWaterHc.count > 0) && 
                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                            <Card 
                                style={{textAlign: 'center',}} 
                                header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Missing Head Count  Site</h3></div>}
                                footer = {this.headCountFooter('Missing Head Count - Site')}
                                >
                                <span style={{color: '#CC3333', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{missingHc.count}</span>
                            </Card>
                        </div> 
                        }

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Main Gate - Assembly Point</h3></div>}
                            footer = {this.headCountFooter('Main Gate HC - Assembly Point')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{mainGateHc.count}</span>
                        </Card>
                        </div>                         

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Sea Water - Assembly Point</h3></div>}
                            footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{seaWaterHc.count}</span>
                        </Card>
                        </div> 

                        </div> 

                        </div>
                    </div>
                }


                { (getLeaveHeadCountChrtAccess !== undefined && getLeaveHeadCountChrtAccess !== false) &&
                    <div className="p-col-12 p-lg1-12 animated fadeIn " >
                        <div className="card " style={{textAlign: 'center'}}>
                        <h1>Leave Statistics - Live</h1>
                            <div className="p-grid p-justify-even">

                            <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                            <Card 
                                style={{textAlign: 'center', }} 
                                header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Annual Leave</h3></div>}
                                footer = {this.LeaveheadCountFooter('Annual Leave')}
                                >
                                <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{AnnualLeaveHC.count}</span>
                            </Card>
                            </div> 

                            <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                            <Card 
                                style={{textAlign: 'center',}} 
                                header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Sick leave 100% Paid</h3></div>}
                                footer = {this.LeaveheadCountFooter('Sick leave 100% Paid')}
                                >
                                <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{SickLeaveHC.count}</span>
                            </Card>
                            </div> 

                            </div> 

                            </div>
                        </div>
                }


                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Aggregative Analysis</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around">

                                    {/* <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>HeadCount</h3>
                                        <Chart type="line" data={pldata} options={ploptions}  />
                                    </div> */}
                                    
                                    <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>Open and Closed Permit</h3>
                                        <Chart type="doughnut" data={openclosepermitdoughdata} options={pdoughoptions} />
                                    </div>
                                    
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12">
                                        <Card 
                                           style={{textAlign: 'center',backgroundColor: '#D2DDCA'}} 
                                            header={<div style={{textAlign: 'center', padding:'1px',  minHeight: '50px'}}><h3>Total Number Of Issued Permit Today</h3></div>}
                                            // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                            >
                                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{"11"}</span>
                                            <h3>Work Permits</h3>
                                        </Card>
                                    </div> 
                                    

                                </div>
                            </div>
                        </div>
                        

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Risk Analysis</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around" >
                                <div className="mt1 " style={{  height: 400,width:720,margin: "0", padding: "0",textAlign: 'center' } } >
                                        <h3>Isolation by Location</h3>
                                        <Chart type="pie" data={ppiedata} options={ppieoptions}   />
                                    </div>
                                    
                                    <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>High Risk and Low Risk Permit</h3>
                                        <Chart type="doughnut" data={riskpermitdoughdata} options={pdoughoptions} />
                                    </div>
                                    
{/*                                     <div className="" style={{textAlign: 'center'}}>
                                        <h3>HeadCount by Age Range</h3>
                                        <Chart type="bar" data={pbvdata} options={pbvoptions} />
                                    </div> */}
                                    


                                </div>
                            </div>
                        </div>



{/*                         <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Leave Days</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around" >
                                    <div className="">
                                        <h3>Leave Taken</h3>
                                        <Chart type="line" data={pldata} options={ploptions} />
                                    </div>
                                    
                                    <div className="" style={{textAlign: 'center',}}>
                                        <h3>Leave Taken by Category</h3>
                                        <Chart type="doughnut" data={openclosepermitdoughdata} options={pdoughoptions} />
                                    </div>
                                    
                                    
                                    <div className="" style={{textAlign: 'center',}}>
                                        <h3>No. of Leaves taken by gender</h3>
                                        <Chart type="doughnut" data={openclosepermitdoughdata} options={pdoughoptions} />
                                    </div>
                                    
                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12">
                                        <Card 
                                            style={{textAlign: 'center',}} 
                                            header={<div style={{backgroundColor:'#FF5733', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '50px'}}><h3>Cost Of Remaining Annual Leave</h3></div>}
                                            // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                            >
                                            <span style={{ backgroundColor: '#FF5733', padding:'1px' , fontSize: '45px'}}>{"$69.3 "}</span>
                                            <h3>Million</h3>
                                        </Card>
                                    </div> 

                                </div>
                            </div>
                        </div>
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise</h3>
                                            <MyResponsivePie data={pied}/>

                                    </div>
                                 
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise</h3>
                                            <MyResponsivePie data={pied}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance Department-wise</h3>
                                            <MyResponsivePie data={pied}/>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin:{ top: 80, right: 100, bottom: 80, left: 100 }, padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Time and Attendance</h2></b>
                                </div>
                            </div>
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around">
                                    <div className="p-col-3">
                                        <h3>Leave Taken</h3>
                                        <Chart type="polarArea" data={ppdata} options={ppoptions} style={{  height: 450,width:400,margin: "0", padding: "0" } }
                                        
                                        />
                                    </div>


                                    <div className="mt1 " style={{textAlign: 'center'}}>
                                        <h3>Department-Wise Absence Rate 1</h3>
                                        <Chart type="bar" data={pbsdata} options={pbsoptions}
                                        
                                        />
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-2 p-sm-12">
                                        <Card 
                                            style={{textAlign: 'center',backgroundColor: '#C70039'}} 
                                            // header={<div style={{backgroundColor:'#808080', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '50px'}}><h3>Cost Of Remaining Annual Leave</h3></div>}
                                            // footer = {this.headCountFooter('Sea Water HC - Assembly Point')}
                                            >
                                            <span style={{ backgroundColor: '#C70039', padding:'1px' , fontSize: '45px'}}>{"1.13%"}</span>
                                            <h3>Abesentism Per Month </h3>
                                        </Card>
                                    </div> 
                                </div>
                            </div>
                        </div>                                              

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Employee Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise</h3>
                                            <MyResponsiveAreaBump data={bumpd}/>

                                    </div>


                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance Department-wise</h3>
                                            <MyResponsiveBump data={bumpd}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Attendance Department-wise</h3>
                                            <MyResponsiveBump data={bumpd}/>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Employee Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                                                  
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise line</h3>
                                            <MyResponsiveLine data={dline}/>

                                    </div>
                                </div>

                            </div>
                        </div>                        



                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   

                                 
                                    <div className="mt1 "  style={{textAlign: 'center',height: 350,width:550 }}>
                                        <h3>Open Positions Department-wise</h3>
                                        <MyResponsiveScatterPlot data={dscatter}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center',height: 350,width:550 }}>
                                        <h3>Attendance Department-wise</h3>
                                        <MyResponsiveSwarmPlot  data={dswarm}  colors={{scheme: 'category10'}} />

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo66</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                   
                                <div className="mt1 "  style={{textAlign: 'center',height: 390,width:390 }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveChord data={chordd}/>

                                    </div>
                                   
                                    <div className="mt1 "  style={{textAlign: 'center',height: 700,width:750 }}>
                                        <h3>Organization Structure</h3>
                                            <MyResponsiveCirclePacking data={organizationData}/>

                                    </div>

                                </div>

                            </div>
                        </div>                        

                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveFunnel data={dfun}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveHeatMap data={dheat}/>

                                    </div>
                                 
                                </div>

                            </div>
                        </div>
                        <div className="mt1 p-col-12 p-grid nested-grid" style={{border: "2px solid grey"}} >
                            <div 
                            className="mt1 p-col-12 p-align-center vertical-container" 
                            style={{backgroundColor: "grey", textAlign: "center", margin: "0", padding: "0", color: "white"}}>
                                <div className="p-col">
                                    <b><h2>Attendance Nivo</h2></b>
                                </div>
                            </div>                           
                            <div className="mt1 p-col-12 ">
                                <div className="p-grid p-justify-around"  style={{overflow: 'hidden', position: 'relative'}}  >                                   
                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveMarimekko data={dmarimekko}/>

                                    </div>

                                    <div className="mt1 "  style={{textAlign: 'center' }}>
                                        <h3>Open Positions Department-wise2</h3>
                                            <MyResponsiveRadar data={dradar}/>

                                    </div>
                                 
                                </div>

                            </div>
                        </div> */}


                        


                        {/* <div className="mt1 p-col-12 p-grid">
                            <div className="p-col-2" style={{backgroundColor:'#406882'}}>
                                <h4>Live Head Count</h4>
                            </div>

                        </div>

                        <div className="mt1 pcol-12 p-grid">
                            <div className="pcol-2" style={{backgroundColor:'#406882'}}>
                                <h4>Leave Days</h4>
                            </div>

                        </div>

                        <div className="mt1 pcol-12 p-grid">
                            <div className="pcol-2" style={{backgroundColor:'#406882'}}>
                                <h4>Time and Attendance</h4>
                            </div>

                        </div> */}
                        
                        
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        OrgUnit: (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        loginUserDetail: state.auth.userDetail,
        userPref : state.auth.userPref,
        // wpCertificateDetails: state.master.tableLists,
         requestListData: state.master.requestListData,
        positionhierarchyData: state.master.positionhierarchyData,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequest: (value) => dispatch(actions.getRequest(value)),
        //getCalendarData: (empId, model, fromDate, toDate) => dispatch(actions.getCalendarData(empId, model, fromDate, toDate)),
        //GetPositionHierachyGraph: (value) => dispatch(actions.GetPositionHierachyGraph(value)),

    }
}



export default connect(mapStateToProps, mapDispatchToProps)(OrgStruct);